<div class="controlContainer" *ngIf="controlType && !controlType.includes('collection')">
  <div class="controlSection" *ngIf="lyricData != null && (controlType == 'text' || controlType == 'lyric')">
    <label>Lyric ({{ layerData?.startLyric }}<span class="text-lowercase">s</span>)</label>
    <div>
      <button type="button" class="btn btn-outline-light btn-sm mr-1 mb-3"
        (click)="textClick(lyricData?.title, 'title')">
        {{ lyricData?.title }}
      </button>

      <button type="button" class="btn btn-outline-light btn-sm mr-1 mb-3" *ngIf="lyricData?.artist != null"
        (click)="textClick(lyricData?.artist, 'artist')">
        {{ lyricData?.artist }}
      </button>
    </div>
  </div>

  <div class="controlSection" *ngIf="controlType.includes('video') || controlType == 'image' || controlType == 'motion'">
    <ng-container *ngIf="controlType != 'motion'">
      <div class="form-row form-group">
        <div class="col-md">
          <button type="button" class="btn smallControlButton" (click)="showOverlay()">
            <svg width="16" height="16" viewBox="0 0 16 16" class="bi bi-search" fill="currentColor"
              xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd"
                d="M10.442 10.442a1 1 0 0 1 1.415 0l3.85 3.85a1 1 0 0 1-1.414 1.415l-3.85-3.85a1 1 0 0 1 0-1.415z" />
              <path fill-rule="evenodd"
                d="M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11zM13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0z" />
            </svg>
            {{ controlType.includes('video') ? 'Videos' : 'Images' }}
          </button>
        </div>

        <div class="col-md" *ngIf="currentHub?.id != null && currentHub.id != -1">
          <button type="button" class="btn smallControlButton" data-toggle="modal" data-target="#hubModal">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-server"
              viewBox="0 0 16 16">
              <path
                d="M1.333 2.667C1.333 1.194 4.318 0 8 0s6.667 1.194 6.667 2.667V4c0 1.473-2.985 2.667-6.667 2.667S1.333 5.473 1.333 4V2.667z" />
              <path
                d="M1.333 6.334v3C1.333 10.805 4.318 12 8 12s6.667-1.194 6.667-2.667V6.334a6.51 6.51 0 0 1-1.458.79C11.81 7.684 9.967 8 8 8c-1.966 0-3.809-.317-5.208-.876a6.508 6.508 0 0 1-1.458-.79z" />
              <path
                d="M14.667 11.668a6.51 6.51 0 0 1-1.458.789c-1.4.56-3.242.876-5.21.876-1.966 0-3.809-.316-5.208-.876a6.51 6.51 0 0 1-1.458-.79v1.666C1.333 14.806 4.318 16 8 16s6.667-1.194 6.667-2.667v-1.665z" />
            </svg>
            Hub
          </button>
        </div>
      </div>

      <div class="form-row form-group">
        <div class="col-md-6">
          <button data-toggle="modal" data-target="#collectionModal" type="button" class="btn smallControlButton text-truncate">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-collection"
              viewBox="0 0 16 16">
              <path d="M2.5 3.5a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1h-11zm2-2a.5.5 0 0 1 0-1h7a.5.5 0 0 1 0 1h-7zM0 13a1.5 1.5 0 0 0 1.5 1.5h13A1.5 1.5 0 0 0 16 13V6a1.5 1.5 0 0 0-1.5-1.5h-13A1.5 1.5 0 0 0 0 6v7zm1.5.5A.5.5 0 0 1 1 13V6a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5h-13z" />
            </svg>
            Collection
          </button>
        </div>
      </div>

      <div *ngIf="controlType.includes('video')" class="form-row form-group align-items-end">
        <div class="col-md">
          <label>Moon source type</label>
          <select class="form-control smallControlSelect" (change)="msSourceTypeChange($event)">
            <option [selected]="layerData?.source_type == 'long'" value="long">Long</option>
            <!-- <option [selected]="layerData?.source_type == 'short'" value="short">Short</option> -->
            <option [selected]="layerData?.source_type == 'footage'" value="footage">Footage</option>
          </select>
        </div>

        <div *ngIf="layerData?.source_type == 'footage'" class="col-md">
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="smoothFade" (change)="smoothFadeChange($event)"
              [checked]="layerData?.footage_cross_transition">
            <label class="custom-control-label" for="smoothFade">Cross Transition</label>
          </div>
        </div>
      </div>

      <div *ngIf="controlType.includes('video')" class="form-row form-group">
        <div class="col-md">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Moon sources</mat-label>

            <mat-select (ngModelChange)="sourceUserChange($event)" [ngModel]="layerData?.source_users" [compareWith]="editorService.matCompareWithId" [sortComparator]="noSortComparator" multiple>
              <mat-select-trigger class="text-light">
                {{ layerData?.source_users?.length ? layerData?.source_users[0].name : '' }}
                <span *ngIf="layerData?.source_users?.length > 1">
                  (+{{ layerData?.source_users.length - 1 }}
                  {{ layerData?.source_users.length == 2 ? 'other' : 'others' }})
                </span>
              </mat-select-trigger>

              <mat-optgroup>
                <mat-form-field class="w-100">
                  <input matInput placeholder="Search" #suVideoFilter (keydown)="$event.stopPropagation()">
                </mat-form-field>
              </mat-optgroup>

              <mat-option *ngFor="let su of sourceUsers"
                [ngClass]="{ 'd-none': !su?.name?.includes(suVideoFilter.value.toLowerCase()) }" [value]="su">
                {{ sourceUserIndex(su?.id) || '' }}
                <svg *ngIf="su?.is_vip == 1" class="bi bi-star-fill text-warning" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                  <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/>
                </svg>
                <svg *ngIf="su?.platform == 'tiktok'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-tiktok mx-1" viewBox="0 0 16 16"><path d="M9 0h1.98c.144.715.54 1.617 1.235 2.512C12.895 3.389 13.797 4 15 4v2c-1.753 0-3.07-.814-4-1.829V11a5 5 0 1 1-5-5v2a3 3 0 1 0 3 3V0Z"/></svg>
                <svg *ngIf="su?.platform == 'douyin'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="red" class="bi bi-douyin mx-1" viewBox="0 0 16 16"><path d="M9 0h1.98c.144.715.54 1.617 1.235 2.512C12.895 3.389 13.797 4 15 4v2c-1.753 0-3.07-.814-4-1.829V11a5 5 0 1 1-5-5v2a3 3 0 1 0 3 3V0Z"/></svg>
                <svg *ngIf="su?.platform == 'youtube'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-youtube mx-1" viewBox="0 0 16 16"><path d="M8.051 1.999h.089c.822.003 4.987.033 6.11.335a2.01 2.01 0 0 1 1.415 1.42c.101.38.172.883.22 1.402l.01.104.022.26.008.104c.065.914.073 1.77.074 1.957v.075c-.001.194-.01 1.108-.082 2.06l-.008.105-.009.104c-.05.572-.124 1.14-.235 1.558a2.007 2.007 0 0 1-1.415 1.42c-1.16.312-5.569.334-6.18.335h-.142c-.309 0-1.587-.006-2.927-.052l-.17-.006-.087-.004-.171-.007-.171-.007c-1.11-.049-2.167-.128-2.654-.26a2.007 2.007 0 0 1-1.415-1.419c-.111-.417-.185-.986-.235-1.558L.09 9.82l-.008-.104A31.4 31.4 0 0 1 0 7.68v-.123c.002-.215.01-.958.064-1.778l.007-.103.003-.052.008-.104.022-.26.01-.104c.048-.519.119-1.023.22-1.402a2.007 2.007 0 0 1 1.415-1.42c.487-.13 1.544-.21 2.654-.26l.17-.007.172-.006.086-.003.171-.007A99.788 99.788 0 0 1 7.858 2h.193zM6.4 5.209v4.818l4.157-2.408L6.4 5.209z"/></svg>
                <svg *ngIf="su?.platform == 'youtube-long'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-youtube mx-1" viewBox="0 0 16 16"><path d="M8.051 1.999h.089c.822.003 4.987.033 6.11.335a2.01 2.01 0 0 1 1.415 1.42c.101.38.172.883.22 1.402l.01.104.022.26.008.104c.065.914.073 1.77.074 1.957v.075c-.001.194-.01 1.108-.082 2.06l-.008.105-.009.104c-.05.572-.124 1.14-.235 1.558a2.007 2.007 0 0 1-1.415 1.42c-1.16.312-5.569.334-6.18.335h-.142c-.309 0-1.587-.006-2.927-.052l-.17-.006-.087-.004-.171-.007-.171-.007c-1.11-.049-2.167-.128-2.654-.26a2.007 2.007 0 0 1-1.415-1.419c-.111-.417-.185-.986-.235-1.558L.09 9.82l-.008-.104A31.4 31.4 0 0 1 0 7.68v-.123c.002-.215.01-.958.064-1.778l.007-.103.003-.052.008-.104.022-.26.01-.104c.048-.519.119-1.023.22-1.402a2.007 2.007 0 0 1 1.415-1.42c.487-.13 1.544-.21 2.654-.26l.17-.007.172-.006.086-.003.171-.007A99.788 99.788 0 0 1 7.858 2h.193zM6.4 5.209v4.818l4.157-2.408L6.4 5.209z"/></svg>
                <svg *ngIf="su?.platform == 'facebook'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-facebook mx-1" viewBox="0 0 16 16"><path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951z"/></svg>
                <svg *ngIf="su?.platform == 'instagram'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-instagram mx-1" viewBox="0 0 16 16"> <path d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.917 3.917 0 0 0-1.417.923A3.927 3.927 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.916 3.916 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.926 3.926 0 0 0-.923-1.417A3.911 3.911 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0h.003zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599.28.28.453.546.598.92.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.47 2.47 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.478 2.478 0 0 1-.92-.598 2.48 2.48 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233 0-2.136.008-2.388.046-3.231.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92.28-.28.546-.453.92-.598.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045v.002zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92zm-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217zm0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334"/></svg>
                <svg *ngIf="su?.platform == 'mix'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-shuffle mx-1" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M0 3.5A.5.5 0 0 1 .5 3H1c2.202 0 3.827 1.24 4.874 2.418.49.552.865 1.102 1.126 1.532.26-.43.636-.98 1.126-1.532C9.173 4.24 10.798 3 13 3v1c-1.798 0-3.173 1.01-4.126 2.082A9.624 9.624 0 0 0 7.556 8a9.624 9.624 0 0 0 1.317 1.918C9.828 10.99 11.204 12 13 12v1c-2.202 0-3.827-1.24-4.874-2.418A10.595 10.595 0 0 1 7 9.05c-.26.43-.636.98-1.126 1.532C4.827 11.76 3.202 13 1 13H.5a.5.5 0 0 1 0-1H1c1.798 0 3.173-1.01 4.126-2.082A9.624 9.624 0 0 0 6.444 8a9.624 9.624 0 0 0-1.317-1.918C4.172 5.01 2.796 4 1 4H.5a.5.5 0 0 1-.5-.5z"/><path d="M13 5.466V1.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384l-2.36 1.966a.25.25 0 0 1-.41-.192zm0 9v-3.932a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384l-2.36 1.966a.25.25 0 0 1-.41-.192z"/></svg>
                <svg *ngIf="su?.platform == 'collection'" class="mx-1" style="width:1.5rem;height:1.5rem" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" d="M3.75 12h16.5m-16.5 3.75h16.5M3.75 19.5h16.5M5.625 4.5h12.75a1.875 1.875 0 010 3.75H5.625a1.875 1.875 0 010-3.75z"></path></svg>
                <svg *ngIf="su?.platform == 'canva'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0,0,300,300" style="width:1.5rem;height:1.5rem;fill:#71717a" class="mx-1"><g fill="#71717a" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode:normal"><g transform="scale(5.12,5.12)"><path d="M25,2c-12.683,0 -23,10.317 -23,23c0,12.683 10.317,23 23,23c12.683,0 23,-10.317 23,-23c0,-12.683 -10.317,-23 -23,-23zM24.109,39.954c-6.781,0 -11.176,-5.086 -11.176,-12.782c0,-9.942 6.888,-17.128 14.639,-17.128c4.69,0 7.486,2.361 7.486,5.573c0,3.313 -2.395,5.658 -4.436,5.658c-0.508,0 -0.764,-0.249 -0.764,-0.661c0,-0.917 1.478,-2.295 1.478,-4.896c0,-2.192 -1.338,-3.569 -3.53,-3.569c-4.69,0 -10.029,5.541 -10.029,15.124c0,5.657 2.809,9.753 7.346,9.753c3.924,0 7.314,-2.816 9.277,-6.797c0.174,-0.35 0.341,-0.51 0.531,-0.51c0.275,0 0.538,0.236 0.538,0.75c-0.002,2.324 -4.163,9.485 -11.36,9.485z"></path></g></g></svg>
                <svg *ngIf="su?.platform == 'artlistio'" style="width:1.5rem" class="mx-1" width="16" height="16" viewBox="0  47 13" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M30.5454 1.36828C30.5454 2.12396 29.9328 2.73655 29.1771 2.73655C28.4214 2.73655 27.8088 2.12396 27.8088 1.36828C27.8088 0.612598 28.4214 0 29.1771 0C29.9328 0 30.5454 0.612598 30.5454 1.36828ZM26.6818 12.2524H24.3134V0.508286H26.6818V12.2524ZM23.1691 12.2524V10.1788H21.9933C21.3718 10.1788 21.1366 9.90785 21.1366 9.40022V5.62534H23.1187V3.62885H21.1366V1.21293H18.7682L18.7705 3.62885L17.3444 3.63266L17.3404 5.62534H18.7682V9.7861C18.7682 11.4303 19.5913 12.2524 21.2374 12.2524H23.1691ZM16.1379 3.62885C14.7941 3.62885 14.1222 4.14895 13.6519 4.9207L13.4323 3.63266H11.2835V12.2567H13.6539V8.02656C13.6539 6.71794 14.1894 5.6658 15.6003 5.6658H16.5543V3.63266L16.1379 3.62885ZM27.995 12.2524H30.3802V3.72521H27.995V12.2524ZM35.5116 12.353C33.1096 12.353 31.4802 11.2289 31.3795 9.38345H33.6303C33.7143 10.1384 34.3694 10.6585 35.5284 10.6585C36.5194 10.6585 37.1241 10.3397 37.1241 9.73577C37.1241 9.05717 36.5789 8.98541 35.2934 8.8162L35.142 8.79624C33.1264 8.56136 31.5642 8.10838 31.5642 6.32999C31.5642 4.61871 33.0592 3.49463 35.2764 3.51141C37.5944 3.51141 39.1902 4.53482 39.3077 6.29643H37.0401C36.9729 5.60857 36.3178 5.18914 35.3604 5.18914C34.4365 5.18914 33.8319 5.52468 33.8319 6.07833C33.8319 6.71115 34.5232 6.79471 35.6931 6.93611L35.8139 6.95075C37.796 7.15207 39.4421 7.60506 39.4421 9.55122C39.4421 11.2625 37.8296 12.353 35.5116 12.353ZM45.7217 12.2524V10.1788H44.5459C43.9244 10.1788 43.6892 9.90785 43.6892 9.40023V5.62535H45.6713V3.62886H43.6892V1.21294H41.3208L41.3231 3.62886L39.897 3.63267L39.893 5.62535H41.3208V9.78611C41.3208 11.4303 42.1439 12.2524 43.79 12.2524H45.7217ZM5.02751 12.247H2.14772H0V10.3357L3.49117 1.22374H6.70832L10.1946 10.3335V12.247H7.94583H7.10308H5.02751ZM7.67152 10.1609L5.09734 3.50719L2.48466 10.1609H7.67152Z"></path></svg>
                {{ su?.name }} ({{ (su?.stats && su.stats[layerData?.source_type]) || 0 }})
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <small class="text-white-50 px-1">* Khi chọn Source, URL video sẽ bị ghi đè.</small>
      </div>

      <ng-container *ngTemplateOutlet="tplCodeField"></ng-container>

      <div class="form-row form-group">
        <div class="col-md-6" *ngIf="!layerData?.is_intro && !layerData?.is_outro">
          <button type="button" class="btn text-truncate smallControlButton" (click)="setAsBackground()">
            Set as Background
          </button>
        </div>
        <div class="col-md-3" *ngIf="controlType == 'video'">
          <button type="button" class="btn smallControlButton" [ngClass]="{ 'bg-primary': layerData?.is_intro }"
            (click)="setAsIntro()">Intro</button>
        </div>
        <div class="col-md-3" *ngIf="controlType == 'video'">
          <button type="button" class="btn smallControlButton" [ngClass]="{ 'bg-primary': layerData?.is_outro }"
            (click)="setAsOutro()">Outro</button>
        </div>
      </div>
    </ng-container>

    <!-- <div class="form-row form-group" *ngIf="controlType == 'image' && layerData?.image_url == null">
      <div class="col-md">
        <label>Gradient background</label>
        <div>
          <div class="form-row">
            <div class="col-md">
              <input class="form-control smallControlInput" data-toggle="modal" data-target="#colorPicker" type="text"
                placeholder="Color1" value="{{ layerData?.gradient?.color1 }}" (click)="color1Change($event)" />
            </div>
            <div class="col-md">
              <input class="form-control smallControlInput" data-toggle="modal" data-target="#colorPicker" type="text"
                placeholder="Color2" value="{{ layerData?.gradient?.color2 }}" (click)="color2Change($event)" />
            </div>
            <div class="col-md">
              <select class="form-control smallControlSelect" (change)="directionChange($event)">
                <option value="none">None</option>
                <option value="top" [selected]="layerData?.gradient?.direction == 'top'">Top</option>
                <option value="left" [selected]="layerData?.gradient?.direction == 'left'">Left</option>
                <option value="bottom" [selected]="layerData?.gradient?.direction == 'bottom'">Bottom</option>
                <option value="right" [selected]="layerData?.gradient?.direction == 'right'">Right</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <div class="form-row form-group" *ngIf="controlType == 'video' && (layerData?.is_intro || layerData?.is_outro)">
      <div class="col-md">
        <div class="custom-control custom-checkbox">
          <input type="checkbox" class="custom-control-input" id="useMusicBg" (change)="useMusicBgChange($event)"
            [checked]="layerData?.is_intro_use_music_bg">
          <label class="custom-control-label" for="useMusicBg">Use Music BG</label>
        </div>
      </div>
    </div>

    <div class="form-row form-group" *ngIf="(controlType == 'video' && !layerData?.is_intro && !layerData?.is_outro) || controlType == 'motion'">
      <div class="col-md">
        <div class="custom-control custom-checkbox">
          <input type="checkbox" class="custom-control-input" id="loop" (change)="loopChange($event)"
            [checked]="layerData?.isLoop">
          <label class="custom-control-label" for="loop">Loop</label>
        </div>
      </div>

      <div class="col-md">
        <div class="custom-control custom-checkbox">
          <input type="checkbox" class="custom-control-input" id="smoothLoop" (change)="smoothLoopChange($event)"
            [checked]="layerData?.isSmoothLoop">
          <label class="custom-control-label" for="smoothLoop">Smooth Loop</label>
        </div>
      </div>
    </div>

    <ng-container *ngIf="!layerData?.is_intro && !layerData?.is_outro && controlType != 'motion'">
      <div class="form-row form-group">
        <div class="col-md">
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="canvasBg" (change)="canvasBgChange($event)"
              [checked]="layerData?.isBackground">
            <label class="custom-control-label" for="canvasBg">Background</label>
          </div>
        </div>

        <div *ngIf="controlType != 'video_background'" class="col-md">
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="mute" (change)="muteChange($event)"
              [checked]="layerData?.isMute">
            <label class="custom-control-label" for="mute">Mute Audio</label>
          </div>
        </div>
      </div>

      <div *ngIf="controlType != 'video_background'" class="form-row form-group">
        <div class="col-md">
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="mask" (change)="maskChange($event)"
              [checked]="layerData?.isMask">
            <label class="custom-control-label" for="mask">Remove BG</label>
          </div>
        </div>

        <div class="col-md" *ngIf="layerData?.isMask">
          <input class="form-control smallControlInput" [ngClass]="{ 'is-invalid': maskColorInvalid }"
            placeholder="r,g,b (required)" type="text" value="{{ layerData?.maskColor }}"
            (change)="maskColorChange($event)" />
          <div class="d-flex align-items-center mt-1">
            <div style="background: rgb(0,0,0); height: 10px; width: 10px; margin-right: 5px;"
              (click)="maskColorChange('0,0,0', true)"></div>
            <div style="background: rgb(255,255,255); height: 10px; width: 10px; margin-right: 5px;"
              (click)="maskColorChange('255,255,255', true)"></div>
            <div style="background: rgb(255,0,0); height: 10px; width: 10px; margin-right: 5px;"
              (click)="maskColorChange('255,0,0', true)"></div>
            <div style="background: rgb(0,255,0); height: 10px; width: 10px; margin-right: 5px;"
              (click)="maskColorChange('0,255,0', true)"></div>
            <div style="background: rgb(0,0,255); height: 10px; width: 10px; margin-right: 5px;"
              (click)="maskColorChange('0,0,255', true)"></div>
          </div>
        </div>
      </div>

      <div *ngIf="(layerData?.position?.width >= 1280 && layerData?.position?.height >= 720) || (layerData?.position?.width >= 720 && layerData?.position?.height >= 1280)"
        class="form-row form-group">
        <div class="col-md">
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="smartCrop" (change)="smartCropChange($event)"
              [checked]="layerData?.smart_crop">
            <label class="custom-control-label" for="smartCrop">Smart Crop</label>
          </div>
        </div>
      </div>
    </ng-container>
  </div>

  <div class="controlSection" *ngIf="controlType == 'mix_lyric'">
    <div class="form-row form-group">
      <div class="col-md">
        <button (click)="btnAddMusic($event)" data-toggle="modal" data-target="#mixLyricModal" type="button"
          class="btn smallControlButton">
          Music
        </button>
      </div>

      <div class="col-md">
        <div class="btn-group w-100">
          <button type="button" class="btn smallControlButton" data-toggle="modal" data-target="#hubModal"
            data-backdrop="static">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-server"
              viewBox="0 0 16 16">
              <path
                d="M1.333 2.667C1.333 1.194 4.318 0 8 0s6.667 1.194 6.667 2.667V4c0 1.473-2.985 2.667-6.667 2.667S1.333 5.473 1.333 4V2.667z" />
              <path
                d="M1.333 6.334v3C1.333 10.805 4.318 12 8 12s6.667-1.194 6.667-2.667V6.334a6.51 6.51 0 0 1-1.458.79C11.81 7.684 9.967 8 8 8c-1.966 0-3.809-.317-5.208-.876a6.508 6.508 0 0 1-1.458-.79z" />
              <path
                d="M14.667 11.668a6.51 6.51 0 0 1-1.458.789c-1.4.56-3.242.876-5.21.876-1.966 0-3.809-.316-5.208-.876a6.51 6.51 0 0 1-1.458-.79v1.666C1.333 14.806 4.318 16 8 16s6.667-1.194 6.667-2.667v-1.665z" />
            </svg>
            Source
          </button>
          <svg width="16" height="16" viewBox="0 0 16 16"
            class="bi bi-arrow-counterclockwise btn p-1 smallControlButtonIcon" fill="currentColor"
            xmlns="http://www.w3.org/2000/svg" (click)="clearSource()">
            <path fill-rule="evenodd" d="M8 3a5 5 0 1 1-4.546 2.914.5.5 0 0 0-.908-.417A6 6 0 1 0 8 2v1z" />
            <path
              d="M8 4.466V.534a.25.25 0 0 0-.41-.192L5.23 2.308a.25.25 0 0 0 0 .384l2.36 1.966A.25.25 0 0 0 8 4.466z" />
          </svg>
        </div>
      </div>
    </div>
  </div>

  <div class="controlSection" *ngIf="controlType == 'footage'">
    <div class="form-row form-group">
      <div class="col-md">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>Moon sources</mat-label>

          <mat-select (ngModelChange)="sourceUserChange($event)" [ngModel]="layerData?.source_users" [compareWith]="editorService.matCompareWithId" [sortComparator]="noSortComparator" multiple>
            <mat-select-trigger class="text-light">
              {{ layerData?.source_users?.length ? layerData?.source_users[0].name : '' }}
              <span *ngIf="layerData?.source_users?.length > 1">
                (+{{ layerData?.source_users.length - 1 }}
                {{ layerData?.source_users.length == 2 ? 'other' : 'others' }})
              </span>
            </mat-select-trigger>

            <mat-optgroup>
              <mat-form-field class="w-100">
                <input matInput placeholder="Search" #suFilter (keydown)="$event.stopPropagation()">
              </mat-form-field>
            </mat-optgroup>

            <mat-option *ngFor="let su of sourceUsers"
              [ngClass]="{ 'd-none': !su?.name?.includes(suFilter.value.toLowerCase()) }" [value]="su">
              {{ sourceUserIndex(su?.id) || '' }}
              <svg *ngIf="su?.is_vip == 1" class="bi bi-star-fill text-warning" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/>
              </svg>
              <svg *ngIf="su?.platform == 'tiktok'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-tiktok mx-1" viewBox="0 0 16 16"><path d="M9 0h1.98c.144.715.54 1.617 1.235 2.512C12.895 3.389 13.797 4 15 4v2c-1.753 0-3.07-.814-4-1.829V11a5 5 0 1 1-5-5v2a3 3 0 1 0 3 3V0Z"/></svg>
              <svg *ngIf="su?.platform == 'douyin'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="red" class="bi bi-douyin mx-1" viewBox="0 0 16 16"><path d="M9 0h1.98c.144.715.54 1.617 1.235 2.512C12.895 3.389 13.797 4 15 4v2c-1.753 0-3.07-.814-4-1.829V11a5 5 0 1 1-5-5v2a3 3 0 1 0 3 3V0Z"/></svg>
              <svg *ngIf="su?.platform == 'youtube'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-youtube mx-1" viewBox="0 0 16 16"><path d="M8.051 1.999h.089c.822.003 4.987.033 6.11.335a2.01 2.01 0 0 1 1.415 1.42c.101.38.172.883.22 1.402l.01.104.022.26.008.104c.065.914.073 1.77.074 1.957v.075c-.001.194-.01 1.108-.082 2.06l-.008.105-.009.104c-.05.572-.124 1.14-.235 1.558a2.007 2.007 0 0 1-1.415 1.42c-1.16.312-5.569.334-6.18.335h-.142c-.309 0-1.587-.006-2.927-.052l-.17-.006-.087-.004-.171-.007-.171-.007c-1.11-.049-2.167-.128-2.654-.26a2.007 2.007 0 0 1-1.415-1.419c-.111-.417-.185-.986-.235-1.558L.09 9.82l-.008-.104A31.4 31.4 0 0 1 0 7.68v-.123c.002-.215.01-.958.064-1.778l.007-.103.003-.052.008-.104.022-.26.01-.104c.048-.519.119-1.023.22-1.402a2.007 2.007 0 0 1 1.415-1.42c.487-.13 1.544-.21 2.654-.26l.17-.007.172-.006.086-.003.171-.007A99.788 99.788 0 0 1 7.858 2h.193zM6.4 5.209v4.818l4.157-2.408L6.4 5.209z"/></svg>
              <svg *ngIf="su?.platform == 'youtube-long'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-youtube mx-1" viewBox="0 0 16 16"><path d="M8.051 1.999h.089c.822.003 4.987.033 6.11.335a2.01 2.01 0 0 1 1.415 1.42c.101.38.172.883.22 1.402l.01.104.022.26.008.104c.065.914.073 1.77.074 1.957v.075c-.001.194-.01 1.108-.082 2.06l-.008.105-.009.104c-.05.572-.124 1.14-.235 1.558a2.007 2.007 0 0 1-1.415 1.42c-1.16.312-5.569.334-6.18.335h-.142c-.309 0-1.587-.006-2.927-.052l-.17-.006-.087-.004-.171-.007-.171-.007c-1.11-.049-2.167-.128-2.654-.26a2.007 2.007 0 0 1-1.415-1.419c-.111-.417-.185-.986-.235-1.558L.09 9.82l-.008-.104A31.4 31.4 0 0 1 0 7.68v-.123c.002-.215.01-.958.064-1.778l.007-.103.003-.052.008-.104.022-.26.01-.104c.048-.519.119-1.023.22-1.402a2.007 2.007 0 0 1 1.415-1.42c.487-.13 1.544-.21 2.654-.26l.17-.007.172-.006.086-.003.171-.007A99.788 99.788 0 0 1 7.858 2h.193zM6.4 5.209v4.818l4.157-2.408L6.4 5.209z"/></svg>
              <svg *ngIf="su?.platform == 'facebook'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-facebook mx-1" viewBox="0 0 16 16"><path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951z"/></svg>
              <svg *ngIf="su?.platform == 'instagram'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-instagram mx-1" viewBox="0 0 16 16"> <path d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.917 3.917 0 0 0-1.417.923A3.927 3.927 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.916 3.916 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.926 3.926 0 0 0-.923-1.417A3.911 3.911 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0h.003zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599.28.28.453.546.598.92.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.47 2.47 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.478 2.478 0 0 1-.92-.598 2.48 2.48 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233 0-2.136.008-2.388.046-3.231.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92.28-.28.546-.453.92-.598.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045v.002zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92zm-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217zm0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334"/></svg>
              <svg *ngIf="su?.platform == 'mix'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-shuffle mx-1" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M0 3.5A.5.5 0 0 1 .5 3H1c2.202 0 3.827 1.24 4.874 2.418.49.552.865 1.102 1.126 1.532.26-.43.636-.98 1.126-1.532C9.173 4.24 10.798 3 13 3v1c-1.798 0-3.173 1.01-4.126 2.082A9.624 9.624 0 0 0 7.556 8a9.624 9.624 0 0 0 1.317 1.918C9.828 10.99 11.204 12 13 12v1c-2.202 0-3.827-1.24-4.874-2.418A10.595 10.595 0 0 1 7 9.05c-.26.43-.636.98-1.126 1.532C4.827 11.76 3.202 13 1 13H.5a.5.5 0 0 1 0-1H1c1.798 0 3.173-1.01 4.126-2.082A9.624 9.624 0 0 0 6.444 8a9.624 9.624 0 0 0-1.317-1.918C4.172 5.01 2.796 4 1 4H.5a.5.5 0 0 1-.5-.5z"/><path d="M13 5.466V1.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384l-2.36 1.966a.25.25 0 0 1-.41-.192zm0 9v-3.932a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384l-2.36 1.966a.25.25 0 0 1-.41-.192z"/></svg>
              <svg *ngIf="su?.platform == 'collection'" class="mx-1" style="width:1.5rem;height:1.5rem" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" d="M3.75 12h16.5m-16.5 3.75h16.5M3.75 19.5h16.5M5.625 4.5h12.75a1.875 1.875 0 010 3.75H5.625a1.875 1.875 0 010-3.75z"></path></svg>
              <svg *ngIf="su?.platform == 'canva'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0,0,300,300" style="width:1.5rem;height:1.5rem;fill:#71717a" class="mx-1"><g fill="#71717a" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode:normal"><g transform="scale(5.12,5.12)"><path d="M25,2c-12.683,0 -23,10.317 -23,23c0,12.683 10.317,23 23,23c12.683,0 23,-10.317 23,-23c0,-12.683 -10.317,-23 -23,-23zM24.109,39.954c-6.781,0 -11.176,-5.086 -11.176,-12.782c0,-9.942 6.888,-17.128 14.639,-17.128c4.69,0 7.486,2.361 7.486,5.573c0,3.313 -2.395,5.658 -4.436,5.658c-0.508,0 -0.764,-0.249 -0.764,-0.661c0,-0.917 1.478,-2.295 1.478,-4.896c0,-2.192 -1.338,-3.569 -3.53,-3.569c-4.69,0 -10.029,5.541 -10.029,15.124c0,5.657 2.809,9.753 7.346,9.753c3.924,0 7.314,-2.816 9.277,-6.797c0.174,-0.35 0.341,-0.51 0.531,-0.51c0.275,0 0.538,0.236 0.538,0.75c-0.002,2.324 -4.163,9.485 -11.36,9.485z"></path></g></g></svg>
              <svg *ngIf="su?.platform == 'artlistio'" style="width:1.5rem" class="mx-1" width="16" height="16" viewBox="0  47 13" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M30.5454 1.36828C30.5454 2.12396 29.9328 2.73655 29.1771 2.73655C28.4214 2.73655 27.8088 2.12396 27.8088 1.36828C27.8088 0.612598 28.4214 0 29.1771 0C29.9328 0 30.5454 0.612598 30.5454 1.36828ZM26.6818 12.2524H24.3134V0.508286H26.6818V12.2524ZM23.1691 12.2524V10.1788H21.9933C21.3718 10.1788 21.1366 9.90785 21.1366 9.40022V5.62534H23.1187V3.62885H21.1366V1.21293H18.7682L18.7705 3.62885L17.3444 3.63266L17.3404 5.62534H18.7682V9.7861C18.7682 11.4303 19.5913 12.2524 21.2374 12.2524H23.1691ZM16.1379 3.62885C14.7941 3.62885 14.1222 4.14895 13.6519 4.9207L13.4323 3.63266H11.2835V12.2567H13.6539V8.02656C13.6539 6.71794 14.1894 5.6658 15.6003 5.6658H16.5543V3.63266L16.1379 3.62885ZM27.995 12.2524H30.3802V3.72521H27.995V12.2524ZM35.5116 12.353C33.1096 12.353 31.4802 11.2289 31.3795 9.38345H33.6303C33.7143 10.1384 34.3694 10.6585 35.5284 10.6585C36.5194 10.6585 37.1241 10.3397 37.1241 9.73577C37.1241 9.05717 36.5789 8.98541 35.2934 8.8162L35.142 8.79624C33.1264 8.56136 31.5642 8.10838 31.5642 6.32999C31.5642 4.61871 33.0592 3.49463 35.2764 3.51141C37.5944 3.51141 39.1902 4.53482 39.3077 6.29643H37.0401C36.9729 5.60857 36.3178 5.18914 35.3604 5.18914C34.4365 5.18914 33.8319 5.52468 33.8319 6.07833C33.8319 6.71115 34.5232 6.79471 35.6931 6.93611L35.8139 6.95075C37.796 7.15207 39.4421 7.60506 39.4421 9.55122C39.4421 11.2625 37.8296 12.353 35.5116 12.353ZM45.7217 12.2524V10.1788H44.5459C43.9244 10.1788 43.6892 9.90785 43.6892 9.40023V5.62535H45.6713V3.62886H43.6892V1.21294H41.3208L41.3231 3.62886L39.897 3.63267L39.893 5.62535H41.3208V9.78611C41.3208 11.4303 42.1439 12.2524 43.79 12.2524H45.7217ZM5.02751 12.247H2.14772H0V10.3357L3.49117 1.22374H6.70832L10.1946 10.3335V12.247H7.94583H7.10308H5.02751ZM7.67152 10.1609L5.09734 3.50719L2.48466 10.1609H7.67152Z"></path></svg>
              {{ su?.name }} ({{ su?.stats?.footage || 0 }})
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>

  <div class="controlSection" *ngIf="controlType == 'motion'">
    <div class="form-row form-group">
      <div class="col-md">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>Composition</mat-label>

          <mat-select [ngModel]="layerData.comp_data?.composition" (ngModelChange)="compositionChange($event)" [compareWith]="editorService.matCompareWithId">
            <mat-select-trigger class="text-light">
              {{ layerData.comp_data?.composition?.name }}
            </mat-select-trigger>

            <mat-optgroup>
              <mat-form-field class="w-100">
                <input matInput placeholder="Search" #compFilter (keydown)="$event.stopPropagation()">
              </mat-form-field>
            </mat-optgroup>

            <mat-option *ngFor="let c of motionData.compositions"
              [ngClass]="{ 'd-none': !c?.name.toLowerCase().includes(compFilter.value.toLowerCase()) }" [value]="c">
              {{ c?.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div *ngIf="layerData.comp_data?.composition?.schema" class="form-row form-group align-items-end">
      <ng-container *ngFor="let schema of layerData.comp_data.composition.schema; let i = index">
        <div *ngIf="schema?.meta?.interface == 'collection'"
          [ngClass]="{'col-md-12': schema?.meta?.width == 'full', 'col-md-6': schema?.meta?.width != 'full'}">
          <button (click)="interfaceClick($event, schema?.field)" data-toggle="modal" data-target="#collectionModal"
            type="button" class="btn smallControlButton text-truncate">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-collection"
              viewBox="0 0 16 16">
              <path d="M2.5 3.5a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1h-11zm2-2a.5.5 0 0 1 0-1h7a.5.5 0 0 1 0 1h-7zM0 13a1.5 1.5 0 0 0 1.5 1.5h13A1.5 1.5 0 0 0 16 13V6a1.5 1.5 0 0 0-1.5-1.5h-13A1.5 1.5 0 0 0 0 6v7zm1.5.5A.5.5 0 0 1 1 13V6a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5h-13z" />
            </svg>
            Collection
          </button>
        </div>

        <div *ngIf="schema?.meta?.interface == 'input'"
          [ngClass]="{'col-md-12': schema?.meta.width == 'full', 'col-md-6': schema?.meta.width != 'full'}">
          <label [attr.for]="schema?.field">{{ schema?.name }}</label>
          <input [ngModel]="layerData.render_data.data[schema?.field] || schema?.meta?.default_value" (ngModelChange)="interfaceChange($event, schema?.type, schema?.field)" [attr.type]="schema?.type" class="form-control smallControlInput" [attr.id]="schema?.field">
        </div>
      </ng-container>
    </div>
  </div>

  <div class="controlSection"
    *ngIf="controlType == 'text' || controlType == 'text_list' || controlType == 'lyric' || controlType == 'mix_lyric'">
    <div class="form-row form-group" *ngIf="controlType == 'text' || controlType == 'text_list'">
      <div class="col-md">
        <label for="editText">Edit text</label>
        <textarea class="form-control smallControlInput" id="editText" rows="2" [ngModel]="layerData?.text"
          (ngModelChange)="textChange($event)"></textarea>
      </div>
    </div>

    <ng-container *ngIf="controlType == 'text' || controlType == 'text_list' || controlType == 'mix_lyric'; then tplCodeField"></ng-container>

    <div class="form-row form-group" *ngIf="controlType == 'lyric'">
      <div class="col-md">
        <button type="button" class="btn smallControlButton" (click)="editLyricClick()">Edit lyric</button>
      </div>

      <div class="col-md">
        <div class="btn-group w-100">
          <button type="button" class="btn smallControlButton" data-toggle="modal" data-target="#hubModal"
            data-backdrop="static">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-server"
              viewBox="0 0 16 16">
              <path
                d="M1.333 2.667C1.333 1.194 4.318 0 8 0s6.667 1.194 6.667 2.667V4c0 1.473-2.985 2.667-6.667 2.667S1.333 5.473 1.333 4V2.667z" />
              <path
                d="M1.333 6.334v3C1.333 10.805 4.318 12 8 12s6.667-1.194 6.667-2.667V6.334a6.51 6.51 0 0 1-1.458.79C11.81 7.684 9.967 8 8 8c-1.966 0-3.809-.317-5.208-.876a6.508 6.508 0 0 1-1.458-.79z" />
              <path
                d="M14.667 11.668a6.51 6.51 0 0 1-1.458.789c-1.4.56-3.242.876-5.21.876-1.966 0-3.809-.316-5.208-.876a6.51 6.51 0 0 1-1.458-.79v1.666C1.333 14.806 4.318 16 8 16s6.667-1.194 6.667-2.667v-1.665z" />
            </svg>
            Source
          </button>
          <svg width="16" height="16" viewBox="0 0 16 16"
            class="bi bi-arrow-counterclockwise btn p-1 smallControlButtonIcon" fill="currentColor"
            xmlns="http://www.w3.org/2000/svg" (click)="clearSource()">
            <path fill-rule="evenodd" d="M8 3a5 5 0 1 1-4.546 2.914.5.5 0 0 0-.908-.417A6 6 0 1 0 8 2v1z" />
            <path
              d="M8 4.466V.534a.25.25 0 0 0-.41-.192L5.23 2.308a.25.25 0 0 0 0 .384l2.36 1.966A.25.25 0 0 0 8 4.466z" />
          </svg>
        </div>
      </div>
    </div>

    <div *ngIf="controlType == 'lyric'" class="form-row form-group">
      <div class="col-md-6">
        <button data-toggle="modal" data-target="#collectionModal" type="button" class="btn smallControlButton text-truncate">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-collection"
            viewBox="0 0 16 16">
            <path d="M2.5 3.5a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1h-11zm2-2a.5.5 0 0 1 0-1h7a.5.5 0 0 1 0 1h-7zM0 13a1.5 1.5 0 0 0 1.5 1.5h13A1.5 1.5 0 0 0 16 13V6a1.5 1.5 0 0 0-1.5-1.5h-13A1.5 1.5 0 0 0 0 6v7zm1.5.5A.5.5 0 0 1 1 13V6a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5h-13z" />
          </svg>
          Collection
        </button>
      </div>
    </div>

    <div class="form-row form-group d-flex align-items-end">
      <div class="col-md">
        <label for="selectFont">Font</label>
        <div class="btn-group w-100">
          <select class="custom-select smallControlSelect" id="selectFont" (change)="fontChange($event)">
            <option [ngStyle]='{ "font-family": "\"" + item?.file_name + "\"" }'
              [selected]="item?.direct_link == layerData?.font_url" [value]="item?.direct_link"
              *ngFor="let item of fontList?.results">
              {{ item?.file_name }}
            </option>
          </select>
          <svg width="16" height="16" viewBox="0 0 16 16" class="bi bi-plus btn p-1 smallControlButtonIcon"
            fill="currentColor" xmlns="http://www.w3.org/2000/svg" (click)="showOverlay()">
            <path fill-rule="evenodd"
              d="M8 3.5a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5H4a.5.5 0 0 1 0-1h3.5V4a.5.5 0 0 1 .5-.5z" />
            <path fill-rule="evenodd" d="M7.5 8a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1H8.5V12a.5.5 0 0 1-1 0V8z" />
          </svg>
        </div>
      </div>

      <div class="col-md-3" *ngIf="lyricData != null && controlType == 'lyric'">
        <button type="button" class="btn smallControlButton" (click)="checkFont()">Check</button>
      </div>
    </div>

    <div class="form-row form-group d-flex align-items-end">
      <div class="col-md-4">
        <label for="fontSize">Font size</label>
        <input class="form-control smallControlInput" id="fontSize" type="number" value="{{ layerData?.fontSize }}"
          (input)="fontSizeChange($event)" />
      </div>

      <div class="col-md-4" *ngIf="controlType == 'lyric' || controlType == 'text' || controlType == 'mix_lyric'">
        <label for="wrapWidth">Word wrap</label>
        <input class="form-control smallControlInput" id="wrapWidth" type="number" value="{{ layerData?.wrap_width }}"
          (input)="wrapWidthChange($event)" />
      </div>

      <div class="col-md-4" *ngIf="controlType == 'text_list'">
        <label for="numColumns ">Columns</label>
        <input class="form-control smallControlInput" id="numColumns" type="number" value="{{ layerData?.num_columns }}"
          (input)="numColumnsChange($event)" />
      </div>

      <div class="col-md-4" *ngIf="controlType == 'text_list'">
        <label for="minSpacing">Col space</label>
        <input class="form-control smallControlInput" id="minSpacing" type="number" value="{{ layerData?.min_spacing }}"
          (input)="minSpacingChange($event)" title="Min columns spacing" />
      </div>

      <div class="col-md-4" *ngIf="lyricData != null && controlType == 'lyric'">
        <button type="button" class="btn smallControlButton" (click)="calcFontSize()">Auto</button>
      </div>

      <div class="col-md-4" *ngIf="controlType == 'text'">
        <button type="button" class="btn smallControlButton" data-toggle="modal"
          data-target="#effectModal">Effects</button>
      </div>
    </div>

    <div *ngIf="controlType == 'text_list'" class="form-row form-group align-items-end">
      <div class="col-md-4">
        <label for="paddingH">Padding</label>
        <input class="form-control smallControlInput" type="text" id="paddingH" value="{{ layerData?.padding_h }}"
          (input)="paddingHChange($event)" title="Padding bottom" />
      </div>

      <div class="col-md-4">
        <label for="margin">Margin</label>
        <input class="form-control smallControlInput" type="text" id="margin" value="{{ layerData?.margin }}"
          (input)="marginChange($event)" title="Margin around" />
      </div>

      <div class="col-md-4">
        <div class="btn-group dropup">
          <button (click)="testTextList($event)" type="button" class="btn smallControlButton">Test</button>
          <button type="button" class="btn smallControlButton dropdown-toggle dropdown-toggle-split" data-toggle="modal"
            data-target="#textListModal">
            <span class="sr-only">Toggle Modal</span>
          </button>
        </div>
      </div>
    </div>

    <div class="form-row form-group">
      <div class="col-md-4">
        <label for="strokeWidth">Stroke width</label>
        <input class="form-control smallControlInput" type="text" id="strokeWidth" value="{{ layerData?.stroke_width }}"
          (input)="strokeWidthChange($event)" />
      </div>

      <div class="col-md">
        <label for="strokeColor">Stroke color</label>
        <div class="btn-group w-100">
          <input class="form-control smallControlInput" data-toggle="modal" data-target="#colorPicker" id="strokeColor"
            type="text" value="{{ layerData?.stroke_color }}" (click)="strokeColorChange($event)" />
          <svg width="16" height="16" viewBox="0 0 16 16"
            class="bi bi-arrow-counterclockwise btn p-1 smallControlButtonIcon" fill="currentColor"
            xmlns="http://www.w3.org/2000/svg" (click)="clearStroke()">
            <path fill-rule="evenodd" d="M8 3a5 5 0 1 1-4.546 2.914.5.5 0 0 0-.908-.417A6 6 0 1 0 8 2v1z" />
            <path
              d="M8 4.466V.534a.25.25 0 0 0-.41-.192L5.23 2.308a.25.25 0 0 0 0 .384l2.36 1.966A.25.25 0 0 0 8 4.466z" />
          </svg>
        </div>
      </div>
    </div>

    <div class="form-row form-group">
      <div class="col-md">
        <label for="textColor">Color</label>
        <input class="form-control smallControlInput" data-toggle="modal" data-target="#colorPicker" id="textColor"
          type="text" value="{{ layerData?.color }}" (click)="textColorChange($event)" />
      </div>

      <div *ngIf="controlType != 'text_list'" class="col-md">
        <label for="textBgColor">Background color</label>
        <div class="btn-group w-100">
          <input class="form-control smallControlInput" data-toggle="modal" data-target="#colorPicker" id="textBgColor"
            type="text" value="{{ layerData?.backgroundColor }}" (click)="textBgColorChange($event)" />
          <svg width="16" height="16" viewBox="0 0 16 16"
            class="bi bi-arrow-counterclockwise btn p-1 smallControlButtonIcon" fill="currentColor"
            xmlns="http://www.w3.org/2000/svg" (click)="clearBgColor()">
            <path fill-rule="evenodd" d="M8 3a5 5 0 1 1-4.546 2.914.5.5 0 0 0-.908-.417A6 6 0 1 0 8 2v1z" />
            <path
              d="M8 4.466V.534a.25.25 0 0 0-.41-.192L5.23 2.308a.25.25 0 0 0 0 .384l2.36 1.966A.25.25 0 0 0 8 4.466z" />
          </svg>
        </div>
      </div>
    </div>
  </div>

  <div class="controlSection"
    *ngIf="!['lyric', 'element', 'compilation', 'mix_lyric', 'footage', 'motion', 'video_background'].includes(controlType) && !layerData?.is_intro && !layerData?.is_outro">
    <div class="form-row form-group">
      <div class="col-md-6">
        <div class="custom-control custom-checkbox">
          <input type="checkbox" class="custom-control-input" id="audioLoop" (change)="audioLoopChange($event)"
            [checked]="layerData?.audio_loop">
          <label class="custom-control-label" for="audioLoop">Audio Loop</label>
        </div>
      </div>

      <div class="col-md-6">
        <div class="btn-group w-100">
          <button type="button" class="btn smallControlButton"
            [ngClass]="{ 'bg-primary': layerData?.audio_url != null }" (click)="audioClick()">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-music-note"
              viewBox="0 0 16 16">
              <path d="M9 13c0 1.105-1.12 2-2.5 2S4 14.105 4 13s1.12-2 2.5-2 2.5.895 2.5 2z" />
              <path fill-rule="evenodd" d="M9 3v10H8V3h1z" />
              <path d="M8 2.82a1 1 0 0 1 .804-.98l3-.6A1 1 0 0 1 13 2.22V4L8 5V2.82z" />
            </svg>
            Audio
          </button>
          <svg width="16" height="16" viewBox="0 0 16 16"
            class="bi bi-arrow-counterclockwise btn p-1 smallControlButtonIcon" fill="currentColor"
            xmlns="http://www.w3.org/2000/svg" (click)="clearAudio()">
            <path fill-rule="evenodd" d="M8 3a5 5 0 1 1-4.546 2.914.5.5 0 0 0-.908-.417A6 6 0 1 0 8 2v1z" />
            <path
              d="M8 4.466V.534a.25.25 0 0 0-.41-.192L5.23 2.308a.25.25 0 0 0 0 .384l2.36 1.966A.25.25 0 0 0 8 4.466z" />
          </svg>
        </div>
      </div>
    </div>
  </div>

  <div class="controlSection" *ngIf="controlType == 'element'">
    <div class="form-row form-group">
      <div class="col-md">
        <label for="rate_summon">Shape / seconds</label>
        <input class="form-control smallControlInput" id="rate_summon" type="number" min="1"
          value="{{ layerData?.rate_summon }}" (input)="rateSummonChange($event)" />
      </div>

      <div class="col-md">
        <label>Shapes <span class="text-info font-weight-bold">({{ layerData?.arr_summon_template.length
            }})</span></label>
        <div class="btn-group w-100">
          <button type="button" class="btn smallControlButton" data-toggle="modal" data-target="#summonTemplates">
            <svg width="16" height="16" viewBox="0 0 16 16" class="bi bi-three-dots m-0" fill="currentColor"
              xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd"
                d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z" />
            </svg>
          </button>
          <svg width="16" height="16" viewBox="0 0 16 16"
            class="bi bi-arrow-counterclockwise btn p-1 smallControlButtonIcon" fill="currentColor"
            xmlns="http://www.w3.org/2000/svg" (click)="clearSummonTemplate()">
            <path fill-rule="evenodd" d="M8 3a5 5 0 1 1-4.546 2.914.5.5 0 0 0-.908-.417A6 6 0 1 0 8 2v1z" />
            <path
              d="M8 4.466V.534a.25.25 0 0 0-.41-.192L5.23 2.308a.25.25 0 0 0 0 .384l2.36 1.966A.25.25 0 0 0 8 4.466z" />
          </svg>
        </div>
      </div>
    </div>
    <!-- <div class="form-row form-group">
      <div class="col-md">
        <label for="rang_locx1">Loc x1</label>
        <input class="form-control smallControlInput" id="rang_locx1" type="number"
          value="{{ layerData?.rang_locx[0] }}" (input)="rangLocX1Change($event)" />
      </div>
      <div class="col-md">
        <label for="rang_locx2">Loc x2</label>
        <input class="form-control smallControlInput" id="rang_locx2" type="number"
          value="{{ layerData?.rang_locx[1] }}" (input)="rangLocX2Change($event)" />
      </div>
      <div class="col-md">
        <label for="rang_locy1">Loc y1</label>
        <input class="form-control smallControlInput" id="rang_locy1" type="number"
          value="{{ layerData?.rang_locy[0] }}" (input)="rangLocY1Change($event)" />
      </div>
      <div class="col-md">
        <label for="rang_locy2">Loc y2</label>
        <input class="form-control smallControlInput" id="rang_locy2" type="number"
          value="{{ layerData?.rang_locy[1] }}" (input)="rangLocY2Change($event)" />
      </div>
    </div> -->
    <div class="form-row form-group">
      <div class="col-md">
        <label for="rang_speedx1">Speed x1</label>
        <input class="form-control smallControlInput" id="rang_speedx1" type="number" min="1" max="100"
          value="{{ layerData?.rang_speedx[0] }}" (input)="rangSpeedX1Change($event)" />
      </div>

      <div class="col-md">
        <label for="rang_speedx2">Speed x2</label>
        <input class="form-control smallControlInput" id="rang_speedx2" type="number" min="1" max="100"
          value="{{ layerData?.rang_speedx[1] }}" (input)="rangSpeedX2Change($event)" />
      </div>

      <div class="col-md">
        <label for="rang_speedy1">Speed y1</label>
        <input class="form-control smallControlInput" id="rang_speedy1" type="number" min="1" max="100"
          value="{{ layerData?.rang_speedy[0] }}" (input)="rangSpeedY1Change($event)" />
      </div>

      <div class="col-md">
        <label for="rang_speedy2">Speed y2</label>
        <input class="form-control smallControlInput" id="rang_speedy2" type="number" min="1" max="100"
          value="{{ layerData?.rang_speedy[1] }}" (input)="rangSpeedY2Change($event)" />
      </div>
    </div>

    <div class="form-row form-group">
      <div class="col-md">
        <label for="rang_opacity1">Opacity from</label>
        <input class="form-control smallControlInput" id="rang_opacity1" type="number" min="1" max="1000"
          value="{{ layerData?.rang_opacity[0] }}" (input)="rangOpacity1Change($event)" />
      </div>

      <div class="col-md">
        <label for="rang_opacity2">Opacity to</label>
        <input class="form-control smallControlInput" id="rang_opacity2" type="number" min="1" max="1000"
          value="{{ layerData?.rang_opacity[1] }}" (input)="rangOpacity2Change($event)" />
      </div>
    </div>

    <div class="form-row form-group">
      <div class="col-md">
        <label for="rang_size1">Size from</label>
        <input class="form-control smallControlInput" id="rang_size1" type="number" min="1" max="100"
          value="{{ layerData?.rang_size[0] }}" (input)="rangSize1Change($event)" />
      </div>

      <div class="col-md">
        <label for="rang_size2">Size to</label>
        <input class="form-control smallControlInput" id="rang_size2" type="number" min="1" max="100"
          value="{{ layerData?.rang_size[1] }}" (input)="rangSize2Change($event)" />
      </div>
    </div>
  </div>

  <div class="controlSection" *ngIf="controlType == 'compilation'">
    <div class="form-row form-group">
      <div class="col-md">
        <button type="button" class="btn smallControlButton" data-toggle="modal" data-target="#compilationModal"
          (click)="btnAddMusic($event)">
          Music
        </button>
      </div>

      <div class="col-md">
        <div class="btn-group w-100">
          <button type="button" class="btn smallControlButton" data-toggle="modal" data-target="#hubModal"
            data-backdrop="static">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-server"
              viewBox="0 0 16 16">
              <path
                d="M1.333 2.667C1.333 1.194 4.318 0 8 0s6.667 1.194 6.667 2.667V4c0 1.473-2.985 2.667-6.667 2.667S1.333 5.473 1.333 4V2.667z" />
              <path
                d="M1.333 6.334v3C1.333 10.805 4.318 12 8 12s6.667-1.194 6.667-2.667V6.334a6.51 6.51 0 0 1-1.458.79C11.81 7.684 9.967 8 8 8c-1.966 0-3.809-.317-5.208-.876a6.508 6.508 0 0 1-1.458-.79z" />
              <path
                d="M14.667 11.668a6.51 6.51 0 0 1-1.458.789c-1.4.56-3.242.876-5.21.876-1.966 0-3.809-.316-5.208-.876a6.51 6.51 0 0 1-1.458-.79v1.666C1.333 14.806 4.318 16 8 16s6.667-1.194 6.667-2.667v-1.665z" />
            </svg>
            Source
          </button>
          <svg width="16" height="16" viewBox="0 0 16 16"
            class="bi bi-arrow-counterclockwise btn p-1 smallControlButtonIcon" fill="currentColor"
            xmlns="http://www.w3.org/2000/svg" (click)="clearSource()">
            <path fill-rule="evenodd" d="M8 3a5 5 0 1 1-4.546 2.914.5.5 0 0 0-.908-.417A6 6 0 1 0 8 2v1z" />
            <path
              d="M8 4.466V.534a.25.25 0 0 0-.41-.192L5.23 2.308a.25.25 0 0 0 0 .384l2.36 1.966A.25.25 0 0 0 8 4.466z" />
          </svg>
        </div>
      </div>
    </div>

    <ng-container *ngTemplateOutlet="tplCodeField"></ng-container>

    <div class="form-row form-group">
      <div class="col-md-6">
        <button data-toggle="modal" data-target="#collectionModal" type="button" class="btn smallControlButton text-truncate">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-collection"
            viewBox="0 0 16 16">
            <path d="M2.5 3.5a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1h-11zm2-2a.5.5 0 0 1 0-1h7a.5.5 0 0 1 0 1h-7zM0 13a1.5 1.5 0 0 0 1.5 1.5h13A1.5 1.5 0 0 0 16 13V6a1.5 1.5 0 0 0-1.5-1.5h-13A1.5 1.5 0 0 0 0 6v7zm1.5.5A.5.5 0 0 1 1 13V6a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5h-13z" />
          </svg>
          Collection
        </button>
      </div>

      <div class="col-md-6">
        <div class="btn-group w-100">
          <button (click)="sourceType = 9; getSoundEffect()" type="button" class="btn smallControlButton" data-toggle="modal" data-target="#soundEffectModal"
            data-backdrop="static">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-soundwave" viewBox="0 0 16 16">
              <path fill-rule="evenodd" d="M8.5 2a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-1 0v-11a.5.5 0 0 1 .5-.5m-2 2a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5m4 0a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5m-6 1.5A.5.5 0 0 1 5 6v4a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m8 0a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m-10 1A.5.5 0 0 1 3 7v2a.5.5 0 0 1-1 0V7a.5.5 0 0 1 .5-.5m12 0a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0V7a.5.5 0 0 1 .5-.5"/>
            </svg>
            SFX
          </button>
          <svg (click)="clearSoundEffect()" width="16" height="16" viewBox="0 0 16 16"
            class="bi bi-arrow-counterclockwise btn p-1 smallControlButtonIcon" fill="currentColor"
            xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" d="M8 3a5 5 0 1 1-4.546 2.914.5.5 0 0 0-.908-.417A6 6 0 1 0 8 2v1z" />
            <path
              d="M8 4.466V.534a.25.25 0 0 0-.41-.192L5.23 2.308a.25.25 0 0 0 0 .384l2.36 1.966A.25.25 0 0 0 8 4.466z" />
          </svg>
        </div>
      </div>
    </div>

    <div class="form-row form-group">
      <div class="col-md">
        <div class="custom-control custom-checkbox">
          <input type="checkbox" class="custom-control-input" id="trimSilence" (change)="trimSilenceChange($event)"
            [checked]="layerData?.is_trim_silence">
          <label class="custom-control-label text-nowrap" for="trimSilence">Cut silent parts</label>
        </div>
      </div>

      <div class="col-md d-flex align-items-center" *ngIf="layerData?.is_trim_silence">
        <div class="mr-1">&lt;</div>
        <input class="form-control smallControlInput" placeholder="Threshold" type="number" value="{{ layerData?.silence_threshold || -30 }}"
          (change)="silenceThresholdChange($event)" />
        <div class="ml-1">dB</div>
      </div>

      <small class="text-white-50 px-1">Pop, Rap, R&B: -30, Relax: -50, Rock: -10</small>
    </div>

    <div class="form-row form-group">
      <div class="col-md">
        <div class="custom-control custom-checkbox">
          <input type="checkbox" class="custom-control-input" id="strict" (change)="strictChange($event)"
            [checked]="layerData?.strict">
          <label class="custom-control-label text-nowrap" for="strict">Strict</label>
        </div>
        <small class="text-white-50 px-1 d-block">Nếu một bài nhạc bị lỗi thì video sẽ không render được</small>
      </div>
    </div>
  </div>

  <div class="controlSection" *ngIf="controlType != 'compilation' && !layerData?.is_intro && !layerData?.is_outro">
    <div *ngIf="controlType != 'mix_lyric' && controlType != 'footage'" class="form-row form-group">
      <div class="col-md-6" *ngIf="controlType != 'element'">
        <label for="startTime">Start time</label>
        <input class="form-control smallControlInput" id="startTime" type="number" value="{{ layerData?.startTime }}"
          (input)="startTimeChange($event)" />
      </div>

      <div class="col-md-6" *ngIf="controlType != 'lyric' && controlType != 'element'">
        <label for="duration">Duration</label>
        <input class="form-control smallControlInput" id="duration" type="number" value="{{ layerData?.duration }}"
          (input)="durationChange($event)" />
      </div>

      <div class="col-md-6" *ngIf="controlType == 'element'">
        <label for="delay">Delay</label>
        <input class="form-control smallControlInput" id="delay" type="number" min="0" value="{{ layerData?.delay }}"
          (input)="delayChange($event)" />
      </div>

      <div class="col-md-6" *ngIf="controlType == 'element'">
        <label>Color <span class="text-info font-weight-bold">({{ layerData?.arr_color.length }})</span></label>
        <div class="btn-group w-100">
          <button type="button" class="btn smallControlButton" data-toggle="modal" data-target="#colorPicker"
            (click)="summonColor()">
            <svg width="16" height="16" viewBox="0 0 16 16" class="bi bi-droplet-fill m-0" fill="currentColor"
              xmlns="http://www.w3.org/2000/svg" *ngIf="layerData?.arr_color.length == 0">
              <path fill-rule="evenodd"
                d="M8 16a6 6 0 0 0 6-6c0-1.655-1.122-2.904-2.432-4.362C10.254 4.176 8.75 2.503 8 0c0 0-6 5.686-6 10a6 6 0 0 0 6 6zM6.646 4.646c-.376.377-1.272 1.489-2.093 3.13l.894.448c.78-1.559 1.616-2.58 1.907-2.87l-.708-.708z" />
            </svg>
            <div class="d-flex flex-wrap align-items-center" style="overflow: hidden; height: 10px;">
              <div [ngStyle]="{background: color, width: '10px', height: '10px', marginRight: '5px'}"
                *ngFor="let color of layerData?.arr_color" (click)="deleteSummonColor(color)"></div>
            </div>
          </button>
          <svg width="16" height="16" viewBox="0 0 16 16"
            class="bi bi-arrow-counterclockwise btn p-1 smallControlButtonIcon" fill="currentColor"
            xmlns="http://www.w3.org/2000/svg" (click)="clearSummonColor()">
            <path fill-rule="evenodd" d="M8 3a5 5 0 1 1-4.546 2.914.5.5 0 0 0-.908-.417A6 6 0 1 0 8 2v1z" />
            <path
              d="M8 4.466V.534a.25.25 0 0 0-.41-.192L5.23 2.308a.25.25 0 0 0 0 .384l2.36 1.966A.25.25 0 0 0 8 4.466z" />
          </svg>
        </div>
      </div>
    </div>

    <div class="form-group" *ngIf="controlType == 'text'">
      <label>Link layer</label>
      <select class="form-control smallControlSelect" (change)="linkLayerChange($event)">
        <option value="">Choose a link layer</option>
        <ng-container *ngFor="let item of layers">
          <option [value]="item?.id" [selected]="item?.id == layerData?.link_layer" *ngIf="item?.id != layerData?.id">
            {{ item?.text }}_{{ item?.index }}
          </option>
        </ng-container>
      </select>
    </div>

    <div *ngIf="controlType == 'lyric' || controlType == 'mix_lyric'">
      <div class="form-row form-group d-flex align-items-start">
        <div class="col-md">
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="fadeIn" (change)="isFadeInChange($event)"
              [checked]="layerData?.is_fade_in || layerData?.fade_in > 0">
            <label class="custom-control-label" for="fadeIn">Fade in</label>
          </div>

          <div class="mt-2" *ngIf="layerData?.is_fade_in || layerData?.fade_in > 0">
            <input class="form-control smallControlInput" type="number" step="0.1" [ngModel]="layerData?.fade_in"
              (ngModelChange)="fadeInChange($event)">
          </div>
        </div>

        <div class="col-md">
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="fadeOut" (change)="isFadeOutChange($event)"
              [checked]="layerData?.is_fade_out || layerData?.fade_out > 0">
            <label class="custom-control-label" for="fadeOut">Fade out</label>
          </div>

          <div class="mt-2" *ngIf="layerData?.is_fade_out || layerData?.fade_out > 0">
            <input class="form-control smallControlInput" type="number" step="0.1" [ngModel]="layerData?.fade_out"
              (ngModelChange)="fadeOutChange($event)">
          </div>
        </div>
      </div>

      <div class="form-row form-group align-items-end">
        <div class="col-md">
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="lyricMoving" (change)="lyricMovingChange($event)"
              [checked]="layerData?.lyric_moving">
            <label class="custom-control-label" for="lyricMoving">Lyric Moving</label>
          </div>
        </div>

        <div *ngIf="controlType == 'mix_lyric'" class="col-md">
          <label for="lyricLines">Lyric lines</label>
          <input class="form-control smallControlInput" id="lyricLines" type="number"
            value="{{ layerData?.lyric_lines }}" (input)="lyricLinesChange($event)" />
        </div>
      </div>

      <div class="form-row form-group">
        <div class="col-md">
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="mixStrict" (change)="strictChange($event)"
              [checked]="layerData?.strict">
            <label class="custom-control-label" for="mixStrict">Strict</label>
          </div>
          <small class="text-white-50 px-1 d-block">Nếu một bài nhạc bị lỗi thì video sẽ không render được</small>
        </div>
      </div>

      <div *ngIf="controlType == 'lyric'" class="form-row form-group">
        <div class="col-md">
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="lyricOutro" (change)="lyricOutroChange($event)"
              [checked]="layerData?.is_lyric_outro">
            <label class="custom-control-label" for="lyricOutro">Lyric Outro</label>
          </div>

          <div *ngIf="layerData?.is_lyric_outro" class="custom-control custom-checkbox mt-2">
            <input type="checkbox" class="custom-control-input" id="isKeeped" (change)="isKeepedChange($event)"
              [checked]="layerData?.is_keeped">
            <label class="custom-control-label" for="isKeeped">Keep</label>
          </div>

          <div class="form-row mt-2">
            <div class="col-md" *ngIf="layerData?.is_lyric_outro">
              <input class="form-control smallControlInput" type="text" [ngModel]="layerData?.deezer_artist_id"
                (ngModelChange)="deezerArtistIdChange($event)" placeholder="Deezer artist id">
            </div>

            <div class="col-md" *ngIf="layerData?.is_lyric_outro">
              <input class="form-control smallControlInput" type="number" [ngModel]="layerData?.lyric_outro_repeat"
                (ngModelChange)="lyricOutroRepeatChange($event)" placeholder="Lyric outro repeat">
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="layerData?.is_lyric_outro" class="form-row form-group">
        <div class="col-md-6">
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="outroClaim" (change)="outroClaimChange($event)"
              [checked]="layerData?.is_outro_claim">
            <label class="custom-control-label" for="outroClaim">Outro claim</label>
          </div>
        </div>

        <div *ngIf="layerData?.is_outro_claim" class="col-md">
          <select class="form-control smallControlSelect"
            [ngClass]="{ 'mt-2 mb-3': layerData?.outro_claim_topic && false }" [ngModel]="layerData?.outro_claim_topic"
            (ngModelChange)="outroClaimTopicChange($event)">
            <option value="">Choose a claim</option>
            <option [value]="item?.topic" *ngFor="let item of claimList">{{ item?.topic }}</option>
          </select>

          <mat-form-field *ngIf="layerData?.outro_claim_topic && false" class="w-100" appearance="fill">
            <mat-label>Choose a music</mat-label>
            <mat-select [compareWith]="editorService.matCompareWith" [ngModel]="layerData?.outro_claim_music"
              (ngModelChange)="outroClaimMusicChange($event)" multiple>
              <mat-select-trigger class="text-light">
                {{ layerData?.outro_claim_music ? layerData?.outro_claim_music[0]?.title : '' }}
                <span *ngIf="layerData?.outro_claim_music?.length > 1">
                  (+{{ layerData?.outro_claim_music.length - 1 }}
                  {{ layerData?.outro_claim_music.length == 2 ? 'other' : 'others' }})
                </span>
              </mat-select-trigger>

              <mat-optgroup>
                <mat-form-field class="w-100">
                  <input matInput placeholder="Search" #outroFilter (keydown)="$event.stopPropagation()">
                </mat-form-field>
              </mat-optgroup>

              <mat-option *ngFor="let m of musicList.outro"
                [ngClass]="{ 'd-none': !m?.title.toLowerCase().includes(outroFilter.value.toLowerCase()) }" [value]="m">
                {{ m.title }} - {{ m.artist }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="form-row form-group d-flex align-items-end" *ngIf="controlType != 'element'">
      <div class="col-md">
        <label for="canvasX">X</label>
        <input class="form-control smallControlInput" id="canvasX" type="number" value="{{ layerData?.position?.x }}"
          (input)="xChange($event)" />
      </div>

      <div class="col-md">
        <label for="canvasY">Y</label>
        <input class="form-control smallControlInput" id="canvasY" type="number" value="{{ layerData?.position?.y }}"
          (input)="yChange($event)" />
      </div>

      <div class="col-md">
        <label for="canvasWidth">Width</label>
        <input class="form-control smallControlInput" id="canvasWidth" type="number"
          value="{{ layerData?.position?.width }}" (input)="widthChange($event)">
      </div>

      <div [ngClass]="{ 'text-primary': layerData?.isLockRatio }" (click)="lockRatioClick()">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
          class="bi bi-link mb-2 c-pointer" viewBox="0 0 16 16">
          <path
            d="M6.354 5.5H4a3 3 0 0 0 0 6h3a3 3 0 0 0 2.83-4H9c-.086 0-.17.01-.25.031A2 2 0 0 1 7 10.5H4a2 2 0 1 1 0-4h1.535c.218-.376.495-.714.82-1z" />
          <path
            d="M9 5.5a3 3 0 0 0-2.83 4h1.098A2 2 0 0 1 9 6.5h3a2 2 0 1 1 0 4h-1.535a4.02 4.02 0 0 1-.82 1H12a3 3 0 1 0 0-6H9z" />
        </svg>
      </div>

      <div class="col-md">
        <label for="canvasHeight">Height</label>
        <input class="form-control smallControlInput" id="canvasHeight" type="number"
          value="{{ layerData?.position?.height }}" (input)="heightChange($event)">
      </div>
    </div>

    <div class="form-row form-group justify-content-center" *ngIf="controlType != 'element' && controlType != 'footage'">
      <div class="col-md-4 posContainer">
        <div class="posTopLeft" [ngClass]="{ 'posActive': posType == 'TL' }" (click)="positionClick('TL')"></div>
        <div class="posTopCenter" [ngClass]="{ 'posActive': posType == 'TC' }" (click)="positionClick('TC')"></div>
        <div class="posTopRight" [ngClass]="{ 'posActive': posType == 'TR' }" (click)="positionClick('TR')"></div>
        <div class="posCenterLeft" [ngClass]="{ 'posActive': posType == 'CL' }" (click)="positionClick('CL')"></div>
        <div class="posCenterCenter" [ngClass]="{ 'posActive': posType == 'CC' }" (click)="positionClick('CC')"></div>
        <div class="posCenterRight" [ngClass]="{ 'posActive': posType == 'CR' }" (click)="positionClick('CR')"></div>
        <div class="posBottomLeft" [ngClass]="{ 'posActive': posType == 'BL' }" (click)="positionClick('BL')"></div>
        <div class="posBottomCenter" [ngClass]="{ 'posActive': posType == 'BC' }" (click)="positionClick('BC')"></div>
        <div class="posBottomRight" [ngClass]="{ 'posActive': posType == 'BR' }" (click)="positionClick('BR')"></div>
      </div>
    </div>
  </div>

  <div class="controlSection"
    *ngIf="!['element', 'compilation', 'mix_lyric', 'footage', 'video_background'].includes(controlType) && !layerData?.is_intro && !layerData?.is_outro">
    <div class="form-group" *ngIf="controlType == 'image' || controlType == 'video' || controlType == 'motion'">
      <label>Opacity</label>
      <div class="form-row">
        <div class="col-md">
          <input class="form-control-range" style="height: 4px;" type="range" min="0" max="1" step="0.1"
            value="{{ layerData?.opacity }}" (input)="opacityChange($event)">
        </div>
        <div class="col-md-3">
          <input type="number" class="form-control smallControlInput" min="0" max="1" step="0.1"
            value="{{ layerData?.opacity }}" (input)="opacityChange($event)">
        </div>
      </div>
    </div>

    <div *ngIf="controlType != 'motion'" class="form-row form-group">
      <div class="col-md-3">
        <label for="canvasRotate">Rotate</label>
        <input class="form-control smallControlInput" id="canvasRotate" type="number"
          value="{{ layerData?.position?.rotation }}" (input)="rotateChange($event)" />
      </div>
    </div>

    <div *ngIf="controlType == 'text'" class="form-row form-group">
      <div class="col-md-6">
        <label for="text_replace_key">Find</label>
        <input class="form-control smallControlInput" id="text_replace_key" type="text" value="{{ layerData?.text_replace_key }}"
          (input)="textReplaceKeyChange($event)" />
      </div>

      <div class="col-md-6">
        <label for="text_replace_value">Replace</label>
        <input class="form-control smallControlInput" id="text_replace_value" type="text" value="{{ layerData?.text_replace_value }}"
          (input)="textReplaceValueChange($event)" />
      </div>
    </div>
  </div>

  <div class="controlSection">
    <div class="form-row form-group">
      <div class="col-md">
        <label>Layer</label>
        <div class="controlSectionRow">
          <svg width="16" height="16" viewBox="0 0 16 16" class="bi bi-fullscreen smallControlButtonIcon"
            fill="currentColor" xmlns="http://www.w3.org/2000/svg" data-toggle="tooltip"
            data-container=".controlSectionRow" data-placement="top" title="Fullscreen" (click)="fullSizeLayer()">
            <path fill-rule="evenodd"
              d="M1.5 1a.5.5 0 0 0-.5.5v4a.5.5 0 0 1-1 0v-4A1.5 1.5 0 0 1 1.5 0h4a.5.5 0 0 1 0 1h-4zM10 .5a.5.5 0 0 1 .5-.5h4A1.5 1.5 0 0 1 16 1.5v4a.5.5 0 0 1-1 0v-4a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 1-.5-.5zM.5 10a.5.5 0 0 1 .5.5v4a.5.5 0 0 0 .5.5h4a.5.5 0 0 1 0 1h-4A1.5 1.5 0 0 1 0 14.5v-4a.5.5 0 0 1 .5-.5zm15 0a.5.5 0 0 1 .5.5v4a1.5 1.5 0 0 1-1.5 1.5h-4a.5.5 0 0 1 0-1h4a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 1 .5-.5z" />
          </svg>
          <svg width="16" height="16" viewBox="0 0 16 16" class="bi bi-back smallControlButtonIcon" fill="currentColor"
            xmlns="http://www.w3.org/2000/svg" data-toggle="tooltip" data-container=".controlSectionRow"
            data-placement="top" title="Send backward" (click)="sendBackward()">
            <path fill-rule="evenodd"
              d="M0 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-2H2a2 2 0 0 1-2-2V2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H2z" />
          </svg>
          <svg width="16" height="16" viewBox="0 0 16 16" class="bi bi-front smallControlButtonIcon" fill="currentColor"
            xmlns="http://www.w3.org/2000/svg" data-toggle="tooltip" data-container=".controlSectionRow"
            data-placement="top" title="Bring forward" (click)="bringForward()">
            <path fill-rule="evenodd"
              d="M0 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-2H2a2 2 0 0 1-2-2V2zm5 10v2a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-2v5a2 2 0 0 1-2 2H5z" />
          </svg>
          <svg width="16" height="16" viewBox="0 0 16 16" class="bi bi-files smallControlButtonIcon" fill="currentColor"
            xmlns="http://www.w3.org/2000/svg" data-toggle="tooltip" data-container=".controlSectionRow"
            data-placement="top" title="Duplicate" (click)="cloneLayer()">
            <path fill-rule="evenodd"
              d="M4 2h7a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zm0 1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H4z" />
            <path
              d="M6 0h7a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2v-1a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1H4a2 2 0 0 1 2-2z" />
          </svg>
          <svg width="16" height="16" viewBox="0 0 16 16" class="bi bi-trash smallControlButtonIcon" fill="currentColor"
            xmlns="http://www.w3.org/2000/svg" data-toggle="tooltip" data-container=".controlSectionRow"
            data-placement="top" title="Delete" (click)="deleteLayer()">
            <path
              d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
            <path fill-rule="evenodd"
              d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4L4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z" />
          </svg>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal right fade" tabindex="-1" id="colorPicker">
  <div class="modal-dialog modal-sm">
    <div class="modal-content">
      <chrome-picker class="picker w-100" [control]="colorControl"></chrome-picker>
    </div>
  </div>
</div>

<div class="modal fade" tabindex="-1" id="controlModal">
  <div class="modal-dialog modal-dialog-scrollable modal-lg">
    <div class="modal-content bg-dark text-light">
      <div class="modal-header">
        <h5 class="modal-title">
          {{ audioType ? 'Audio' : (controlType == 'text' || controlType == 'text_list' || controlType == 'lyric' ||
          controlType == 'mix_lyric') ? 'Fonts' : controlType.includes('video') ? 'Videos' : 'Images' }}
        </h5>
        <button type="button" class="close" data-dismiss="modal">
          <span>&times;</span>
        </button>
      </div>

      <div class="modal-body">
        <ul class="nav nav-pills" id="overlayTab" role="tablist">
          <li class="nav-item" role="presentation">
            <a class="nav-link active" data-toggle="tab" href="#upload" role="tab">Upload</a>
          </li>
          <li class="nav-item" role="presentation">
            <a class="nav-link" data-toggle="tab" href="#browse" role="tab">Your Uploads</a>
          </li>
          <li class="nav-item" role="presentation" *ngIf="!audioType">
            <a class="nav-link" data-toggle="tab" href="#canva" role="tab">Canva</a>
          </li>
          <li class="nav-item" role="presentation" *ngIf="!audioType">
            <a class="nav-link" data-toggle="tab" href="#yourCanva" role="tab">Your Canva</a>
          </li>
          <li class="nav-item" role="presentation" *ngIf="(layerData?.is_intro || layerData?.is_outro) && !audioType">
            <a class="nav-link" data-toggle="tab" href="#yourIntro" role="tab">Your Intros</a>
          </li>
        </ul>

        <div class="tab-content" id="overlayTabContent">
          <div class="tab-pane fade show active my-3" id="upload" role="tabpanel">
            <div class="input-group"
              *ngIf="(controlType == 'text' || controlType == 'text_list' || controlType == 'lyric' || controlType == 'mix_lyric') && !audioType">
              <div class="custom-file">
                <input type="file" class="custom-file-input" id="fontFile" accept=".ttf,.otf"
                  (change)="fontFileInput($event.target.files[0])">
                <span class="custom-file-label bg-dark border-secondary text-light" for="fontFile">Choose file</span>
              </div>
            </div>

            <div *ngIf="controlType.includes('video') && !audioType">
              <div class="input-group mb-3">
                <div class="custom-file">
                  <input type="file" class="custom-file-input" id="videoFile" accept=".avi,.m4v,.mp4,.webm,.gif"
                    (change)="awsFileInput($event.target.files[0], 'video')">
                  <span class="custom-file-label bg-dark border-secondary text-light" for="videoFile">Choose file (AVI, M4V, MP4, WEBM or GIF)</span>
                </div>
              </div>
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text" for="videoDrive">
                    <img src="https://ssl.gstatic.com/images/branding/product/1x/drive_2020q4_32dp.png" width="20">
                  </span>
                </div>
                <input type="text" class="form-control bg-dark border-secondary text-light"
                  placeholder="Video drive link" id="videoDrive"
                  (keyup.enter)="videoFileInput($event.target.value, 'video-drive')">
              </div>
              <small class="text-muted">
                Example: https://drive.google.com/file/d/0B2zRoYfJBS9pem5LM19IX29yTkE/view?usp=sharing
              </small>
            </div>

            <div *ngIf="controlType == 'image' && !audioType">
              <div class="input-group mb-3">
                <div class="custom-file">
                  <input type="file" class="custom-file-input" id="imageFile" accept="image/*"
                    (change)="awsFileInput($event.target.files[0], 'image')">
                  <span class="custom-file-label bg-dark border-secondary text-light" for="imageFile">Choose
                    file</span>
                </div>
              </div>
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text" for="imageDrive">
                    <img src="https://ssl.gstatic.com/images/branding/product/1x/drive_2020q4_32dp.png" width="20">
                  </span>
                </div>
                <input type="text" class="form-control bg-dark border-secondary text-light"
                  placeholder="Image drive link" id="imageDrive"
                  (keyup.enter)="imageFileInput($event.target.value, 'image-drive')">
              </div>
              <small class="text-muted">
                Example: https://drive.google.com/file/d/0B2zRoYfJBS9pem5LM19IX29yTkE/view?usp=sharing
              </small>
            </div>

            <div class="input-group" *ngIf="audioType">
              <div class="custom-file">
                <input type="file" class="custom-file-input" id="audioFile" accept="audio/*"
                  (change)="audioFileInput($event.target.files[0])">
                <span class="custom-file-label bg-dark border-secondary text-light" for="audioFile">Choose
                  file</span>
              </div>
            </div>
          </div>

          <div class="tab-pane fade my-3" id="browse" role="tabpanel">
            <div class="input-group mb-3">
              <input
                (keyup.enter)="controlType == 'image' ? getImages(1, uploadedInput.value) : controlType.includes('video') ? getVideos(1, uploadedInput.value) : getFonts(1, uploadedInput.value)"
                #uploadedInput type="text" class="form-control bg-dark border-secondary text-light"
                placeholder="Search">
              <div *ngIf="uploadedInput.value"
                (click)="uploadedInput.value = ''; controlType == 'image' ? getImages() : controlType.includes('video') ? getVideos() : getFonts()"
                role="button" class="input-group-append">
                <span class="input-group-text bg-dark border-secondary text-light border-left-0">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg"
                    viewBox="0 0 16 16">
                    <path fill-rule="evenodd"
                      d="M13.854 2.146a.5.5 0 0 1 0 .708l-11 11a.5.5 0 0 1-.708-.708l11-11a.5.5 0 0 1 .708 0Z" />
                    <path fill-rule="evenodd"
                      d="M2.146 2.146a.5.5 0 0 0 0 .708l11 11a.5.5 0 0 0 .708-.708l-11-11a.5.5 0 0 0-.708 0Z" />
                  </svg>
                </span>
              </div>
            </div>

            <div
              *ngIf="(controlType == 'text' || controlType == 'text_list' || controlType == 'lyric' || controlType == 'mix_lyric') && !audioType && fontList?.results.length > 0">
              <ul class="list-group list-group-flush">
                <li
                  [ngClass]="{ 'd-none': !item?.file_name.toLowerCase().includes(uploadedInputEl.nativeElement.value.toLowerCase()) }"
                  class="list-group-item list-group-item-action bg-dark text-light"
                  *ngFor="let item of fontList?.results" (click)="selectedFont(item)">
                  <button (click)="rsDelete(item?.id, 'font');$event.stopPropagation()" type="button"
                    class="btn btn-link text-danger">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                      class="bi bi-trash-fill" viewBox="0 0 16 16">
                      <path
                        d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z" />
                    </svg>
                  </button>

                  <span class="mr-3" [ngStyle]='{ "font-family": "\"" + item?.file_name + "\"" }'>Simple</span>
                  {{ item?.file_name }}
                </li>
              </ul>
              <button type="button" class="loadMore btn btn-block btn-sm btn-secondary" *ngIf="fontList?.page != -1"
                (click)="loadMore('font', fontList?.page, uploadedInputEl.nativeElement.value)">Load more</button>
            </div>

            <div class="thumbnailContainer"
              *ngIf="controlType.includes('video') && !audioType && videoList?.results.length > 0">
              <div *ngFor="let item of videoList?.results" class="thumbnail position-relative" style="width: 169px;">
                <video class="rounded" width="169" [poster]="item?.poster" (click)="selectedVideo(item)"
                  title="{{ item?.file_name }}"></video>

                <div class="text-truncate py-1">{{ item?.file_name }}</div>

                <button (click)="rsDelete(item?.id, 'video');$event.stopPropagation()" type="button"
                  class="btn btn-sm btn-link text-danger position-absolute top-0 right-0">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                    class="bi bi-trash-fill" viewBox="0 0 16 16">
                    <path
                      d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z" />
                  </svg>
                </button>
              </div>

              <button type="button" class="loadMore btn btn-block btn-sm btn-secondary" *ngIf="videoList?.page != -1"
                (click)="loadMore('video', videoList?.page, uploadedInputEl.nativeElement.value)">Load more</button>
            </div>

            <div class="thumbnailContainer"
              *ngIf="controlType == 'image' && !audioType && imageList?.results.length > 0">
              <div *ngFor="let item of imageList?.results" class="thumbnail position-relative" style="width: 169px;">
                <img class="rounded" width="169" [src]="item?.direct_link" (click)="selectedImage(item)"
                  title="{{ item?.file_name }}">

                <div class="text-truncate py-1">{{ item?.file_name }}</div>

                <button (click)="rsDelete(item?.id, 'image');$event.stopPropagation()" type="button"
                  class="btn btn-sm btn-link text-danger position-absolute top-0 right-0">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                    class="bi bi-trash-fill" viewBox="0 0 16 16">
                    <path
                      d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z" />
                  </svg>
                </button>
              </div>

              <button type="button" class="loadMore btn btn-block btn-sm btn-secondary" *ngIf="imageList?.page != -1"
                (click)="loadMore('image', imageList?.page, uploadedInputEl.nativeElement.value)">Load more</button>
            </div>

            <div *ngIf="audioType && audioList?.results.length > 0">
              <ul class="list-group list-group-flush">
                <li class="list-group-item list-group-item-action bg-dark text-light"
                  *ngFor="let item of audioList?.results" (click)="selectedAudio(item)">
                  <button (click)="rsDelete(item?.id, 'audio');$event.stopPropagation()" type="button"
                    class="btn btn-link text-danger">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                      class="bi bi-trash-fill" viewBox="0 0 16 16">
                      <path
                        d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z" />
                    </svg>
                  </button>
                  {{ item?.file_name }}
                </li>
              </ul>
              <button type="button" class="loadMore btn btn-block btn-sm btn-secondary" *ngIf="audioList?.page != -1"
                (click)="loadMore('audio', audioList?.page)">Load more</button>
            </div>
          </div>

          <div class="tab-pane fade my-3" id="canva" role="tabpanel" *ngIf="!audioType">
            <div *ngIf="controlType.includes('video')">
              <div class="form-row form-group">
                <div class="col-md-5">
                  <select class="form-control bg-dark border-secondary text-light" (change)="cateChange($event)">
                    <option value="">Category</option>
                    <option [value]="item" *ngFor="let item of cateList">{{ item }}</option>
                  </select>
                </div>
                <div class="col-md-7 input-group">
                  <input type="text" class="form-control bg-dark border-secondary text-light" #vidSearchtyping
                    placeholder="Search" (keyup.enter)="canvaSearchChange(vidSearchtyping.value)">
                  <div class="input-group-append">
                    <button class="btn btn-secondary" type="button"
                      (click)="canvaSearchChange(vidSearchtyping.value)">Go</button>
                  </div>
                </div>
              </div>
              <div class="thumbnailContainer" *ngIf="canvaList?.results.length > 0; else elseBlock">
                <video class="rounded thumbnail" width="169" *ngFor="let item of canvaList?.results"
                  [poster]="item?.poster | split:',':0" (click)="selectedCanva(item)"></video>
                <button type="button" class="loadMore btn btn-block btn-sm btn-secondary" *ngIf="canvaList?.page != -1"
                  (click)="loadMore('canva', canvaList?.page)">Load more</button>
              </div>
              <ng-template #elseBlock>Search results will appear here</ng-template>
            </div>

            <div *ngIf="controlType == 'image'">
              <div class="mb-3">
                <div class="custom-control custom-radio custom-control-inline">
                  <input type="radio" id="imgSearchKeyword" name="imgSearchType" class="custom-control-input"
                    [(ngModel)]="imgSearchType" value="keyword">
                  <label class="custom-control-label" for="imgSearchKeyword">Keyword</label>
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                  <input type="radio" id="imgSearchTitle" name="imgSearchType" class="custom-control-input"
                    [(ngModel)]="imgSearchType" value="title">
                  <label class="custom-control-label" for="imgSearchTitle">Title</label>
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                  <input type="radio" id="imgSearchId" name="imgSearchType" class="custom-control-input"
                    [(ngModel)]="imgSearchType" value="id">
                  <label class="custom-control-label" for="imgSearchId">ID</label>
                </div>
              </div>
              <div class="input-group mb-3">
                <input type="text" class="form-control bg-dark border-secondary text-light" #imgSearchTyping
                  [placeholder]="imgSearchType == 'keyword' ? 'keyword' : imgSearchType == 'title' ? 'title' : 'id'"
                  (keyup.enter)="imgSearchChange(imgSearchTyping.value)">
                <div class="input-group-append">
                  <button class="btn btn-secondary" type="button"
                    (click)="imgSearchChange(imgSearchTyping.value)">Search</button>
                </div>
              </div>
              <div class="thumbnailContainer" *ngIf="canvaImageList?.results.length > 0; else elseBlock">
                <div class="dropright thumbnail" *ngFor="let item of canvaImageList?.results">
                  <img class="rounded" data-toggle="dropdown" width="169" [src]="getThumbnailImage(item?.sources)" />
                  <div class="dropdown-menu">
                    <h6 class="dropdown-header">Size</h6>
                    <a href="#" class="dropdown-item" *ngFor="let source of item?.sources"
                      (click)="selectedCanvaImage(source)">
                      {{ source?.width }}x{{ source?.height }}
                    </a>
                  </div>
                </div>
                <button type="button" class="loadMore btn btn-block btn-sm btn-secondary"
                  *ngIf="canvaImageList?.page != -1" (click)="loadMore('canvaImage', canvaImageList?.page)">Load
                  more</button>
              </div>
              <ng-template #elseBlock>Search results will appear here</ng-template>
            </div>

            <div
              *ngIf="controlType == 'text' || controlType == 'text_list' || controlType == 'lyric' || controlType == 'mix_lyric'">
              <div class="mb-3">
                <div class="custom-control custom-radio custom-control-inline">
                  <input type="radio" id="fontSearchLocale" name="fontSearchType" class="custom-control-input"
                    [(ngModel)]="fontSearchType" value="locale">
                  <label class="custom-control-label" for="fontSearchLocale">Locale</label>
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                  <input type="radio" id="fontSearchTitle" name="fontSearchType" class="custom-control-input"
                    [(ngModel)]="fontSearchType" value="title">
                  <label class="custom-control-label" for="fontSearchTitle">Title</label>
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                  <input type="radio" id="fontSearchId" name="fontSearchType" class="custom-control-input"
                    [(ngModel)]="fontSearchType" value="id">
                  <label class="custom-control-label" for="fontSearchId">ID</label>
                </div>
              </div>
              <div class="input-group mb-3">
                <input type="text" class="form-control bg-dark border-secondary text-light" #fontSearchTyping
                  [placeholder]="fontSearchType == 'locale' ? 'Locale' : fontSearchType == 'title' ? 'title' : 'id'"
                  (keyup.enter)="fontSearchChange(fontSearchTyping.value)">
                <div class="input-group-append">
                  <button class="btn btn-secondary" type="button"
                    (click)="fontSearchChange(fontSearchTyping.value)">Search</button>
                </div>
              </div>
              <div class="thumbnailContainer" *ngIf="canvaFontList?.results.length > 0; else elseBlock">
                <div class="dropright thumbnail" *ngFor="let item of canvaFontList?.results">
                  <img class="img-thumbnail" data-toggle="dropdown" width="169" [src]="getFontImage(item?.images)" />
                  <div class="dropdown-menu">
                    <h6 class="dropdown-header">Style</h6>
                    <ng-container *ngFor="let source of item?.sources">
                      <a href="#" class="dropdown-item" *ngIf="isTfFont(source)" (click)="selectedCanvaFont(source)">
                        {{ source?.styleName }}
                      </a>
                    </ng-container>
                  </div>
                </div>
                <button type="button" class="loadMore btn btn-block btn-sm btn-secondary"
                  *ngIf="canvaFontList?.page != -1" (click)="loadMore('canvaFont', canvaFontList?.page)">Load
                  more</button>
              </div>
              <ng-template #elseBlock>Search results will appear here</ng-template>
            </div>
          </div>

          <div class="tab-pane fade my-3" id="yourCanva" role="tabpanel" *ngIf="!audioType">
            <div class="input-group mb-3">
              <input #urCanvaChannel (ngModelChange)="urCanvaChannelChange($event)" [ngModel]="urCanva.channel?.name"
                list="urCanvaChannels" placeholder="Channel"
                class="form-control bg-dark border-secondary text-light border-right-0" type="text">
              <div *ngIf="urCanvaChannel.value" (click)="urCanvaChannel.value = ''" role="button" class="input-group-append">
                <span class="input-group-text bg-dark border-secondary text-light">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg"
                    viewBox="0 0 16 16">
                    <path
                      d="M1.293 1.293a1 1 0 0 1 1.414 0L8 6.586l5.293-5.293a1 1 0 1 1 1.414 1.414L9.414 8l5.293 5.293a1 1 0 0 1-1.414 1.414L8 9.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L6.586 8 1.293 2.707a1 1 0 0 1 0-1.414z" />
                  </svg>
                </span>
              </div>
            </div>
            <datalist id="urCanvaChannels">
              <option [value]="item?.chanel_id" *ngFor="let item of channelList">{{ item?.chanel_name }}</option>
            </datalist>

            <div *ngIf="controlType.includes('video')">
              <div class="thumbnailContainer" *ngIf="urCanva.video?.results.length > 0">
                <video class="rounded thumbnail" width="169" *ngFor="let item of urCanva.video?.results"
                  [poster]="item?.poster | split:',':0" (click)="selectedCanva(item)"></video>
              </div>
            </div>

            <div *ngIf="controlType == 'image'">
              <div class="thumbnailContainer" *ngIf="urCanva.image?.results.length > 0">
                <div class="dropright thumbnail" *ngFor="let item of urCanva.image?.results">
                  <img class="rounded" data-toggle="dropdown" width="169" [src]="getThumbnailImage(item?.sources)" />
                  <div class="dropdown-menu">
                    <h6 class="dropdown-header">Size</h6>
                    <a href="#" class="dropdown-item" *ngFor="let source of item?.sources"
                      (click)="selectedCanvaImage(source)">
                      {{ source?.width }}x{{ source?.height }}
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div
              *ngIf="controlType == 'text' || controlType == 'text_list' || controlType == 'lyric' || controlType == 'mix_lyric'">
              <div class="thumbnailContainer" *ngIf="urCanva.font?.results.length > 0">
                <div class="dropright thumbnail" *ngFor="let item of urCanva.font?.results">
                  <img class="img-thumbnail" data-toggle="dropdown" width="169" [src]="getFontImage(item?.images)" />
                  <div class="dropdown-menu">
                    <h6 class="dropdown-header">Style</h6>
                    <ng-container *ngFor="let source of item?.sources">
                      <a href="#" class="dropdown-item" *ngIf="isTfFont(source)" (click)="selectedCanvaFont(source)">
                        {{ source?.styleName }}
                      </a>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="tab-pane fade my-3" id="yourIntro" role="tabpanel">
            <select [(ngModel)]="introData.app" class="custom-select bg-dark border-secondary text-light mb-3">
              <option value="">Choose a app</option>
              <option *ngFor="let app of introData?.topic?.app" [value]="app.app">{{ app.app }}</option>
            </select>

            <div class="row mb-3">
              <div class="col">
                <select [(ngModel)]="introData.channel_type" class="custom-select bg-dark border-secondary text-light">
                  <option value="">Choose a channel type</option>
                  <option *ngFor="let ctype of introData?.topic?.channel_type" [value]="ctype.channel_type">
                    {{ ctype.channel_type }}</option>
                </select>
              </div>

              <div *ngIf="introData?.channel_type == 'SINGLE'" class="col">
                <select [(ngModel)]="introData.channel_id" class="custom-select bg-dark border-secondary text-light">
                  <option value="">Choose a channel</option>
                  <option *ngFor="let cid of introData?.topic?.channel_id" [value]="cid.channel_id">
                    {{ cid.channel_name }}
                  </option>
                </select>
              </div>
            </div>

            <div class="row mb-3">
              <div class="col">
                <select [(ngModel)]="introData.intro_type" class="custom-select bg-dark border-secondary text-light">
                  <option value="">Choose a intro type</option>
                  <option *ngFor="let itype of introData?.topic?.intro_type" [value]="itype.intro_type">
                    {{ itype.intro_type }}
                  </option>
                </select>
              </div>

              <div class="col">
                <select [(ngModel)]="introData.video_type" class="custom-select bg-dark border-secondary text-light">
                  <option value="">Choose a video type</option>
                  <option *ngFor="let vtype of introData?.topic?.video_type" [value]="vtype.video_type">
                    {{ vtype.video_type }}
                  </option>
                </select>
              </div>
            </div>

            <button (click)="getIntroVideos()" type="button" class="btn btn-primary mb-3">Filter</button>

            <div class="thumbnailContainer">
              <div *ngFor="let item of introData.videos" class="thumbnail" style="width: 169px;">
                <img class="rounded" width="169" [src]="item?.intro_thumb" (click)="selectedIntro(item)"
                  title="{{ item?.intro_name }}">

                <div class="text-truncate py-1">{{ item?.intro_name }}</div>
              </div>
            </div>
          </div>

          <div class="d-flex justify-content-center" *ngIf="isLoading">
            <img src="/assets/images/loading.gif" width="50">
          </div>

          <div *ngIf="uploadStatus[uploadStatusType]?.progress && uploadStatus[uploadStatusType]?.progress < 100" class="progress" style="height: 10px;">
            <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" [style.width.%]="uploadStatus[uploadStatusType].progress" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100">
              {{ uploadStatus[uploadStatusType].count }}/{{ uploadStatus[uploadStatusType].total }} files
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal right fade" tabindex="-1" id="summonTemplates">
  <div class="modal-dialog modal-sm">
    <div class="modal-content bg-dark text-light">
      <div class="modal-body">
        <div class="thumbnailContainer" *ngIf="elementList?.results.length > 0">
          <img class="rounded" class="thumbnail" width="45" *ngFor="let item of elementList?.results"
            [ngClass]="{ 'thumbnailActive': layerData?.arr_summon_template != undefined && layerData?.arr_summon_template.indexOf(item?.direct_link) > -1 }"
            [src]="item?.direct_link" (click)="selectedElement(item)" />
          <button type="button" class="loadMore btn btn-block btn-sm btn-secondary" *ngIf="elementList?.page != -1"
            (click)="loadMore('element', elementList?.page)">Load more</button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="compilationModal">
  <div class="modal-dialog modal-dialog-scrollable modal-lg">
    <div class="modal-content bg-dark text-light">
      <div class="modal-header">
        <h5 class="modal-title">Compilation</h5>
        <button type="button" class="close" data-dismiss="modal">
          <span>&times;</span>
        </button>
      </div>

      <div class="modal-body">
        <app-music-picker #musicPicker mode="compilation" [target]="layerData" [boomGenres]="boomGenres"
          [isPortrait]="isPortrait" [validationErrors]="musicValidationErrors"></app-music-picker>

        <ng-container *ngIf="layerData.hasOwnProperty('meta')">
          <div class="form-group">
            <div class="d-flex align-items-center text-truncate mb-2">
              <label class="mr-3 mb-0" for="videoTitle">Title</label>

              <div class="custom-control custom-checkbox custom-control-inline">
                <input type="checkbox" class="custom-control-input" id="isMixTitleUpper"
                  (change)="isTextUpperChange($event, 'title')" [checked]="layerData?.meta?.is_title_upper">
                <label class="custom-control-label" for="isMixTitleUpper">UPPERCASE</label>
              </div>

              <div class="custom-control custom-checkbox custom-control-inline"
                *ngIf="layerData?.meta?.is_title_upper && !layerData?.meta?.hasOwnProperty('title_ucword')">
                <input type="checkbox" class="custom-control-input" id="mixTitleCap"
                  (change)="textCapChange($event, 'title')" [checked]="layerData?.meta?.hasOwnProperty('title_ucfirst')">
                <label class="custom-control-label" for="mixTitleCap">Uppercase Firsts</label>
              </div>

              <div class="custom-control custom-checkbox custom-control-inline"
                *ngIf="layerData?.meta?.is_title_upper && !layerData?.meta?.hasOwnProperty('title_ucfirst') && !layerData?.meta?.hasOwnProperty('title_lowercase')">
                <input type="checkbox" class="custom-control-input" id="mixTitleUpper"
                  (change)="textUpperChange($event, 'title')" [checked]="layerData?.meta?.hasOwnProperty('title_ucword')">
                <label class="custom-control-label" for="mixTitleUpper">UPPERCASE WORDS</label>
              </div>

              <div class="custom-control custom-checkbox custom-control-inline"
                *ngIf="!layerData?.meta?.hasOwnProperty('title_ucword')">
                <input type="checkbox" class="custom-control-input" id="mixTitleLower"
                  (change)="textLowerChange($event, 'title')"
                  [checked]="layerData?.meta?.hasOwnProperty('title_lowercase')">
                <label class="custom-control-label" for="mixTitleLower">lowercase</label>
              </div>

              <div class="custom-control custom-checkbox custom-control-inline">
                <input type="checkbox" class="custom-control-input" id="isMixTitleFontChanged"
                  (change)="isTextFontChanged($event, 'title')" [checked]="layerData?.meta?.is_title_font_changed">
                <label class="custom-control-label" for="isMixTitleFontChanged">Font</label>
              </div>

              <select *ngIf="layerData?.meta?.is_title_font_changed" (change)="textFontChanged($event, 'title')"
                class="form-control bg-dark border-secondary text-light mr-3">
                <option value="">Choose a font</option>
                <option [value]="font.fontName" [selected]="layerData?.meta?.fc_title_font_name == font.fontName"
                  *ngFor="let font of editorService.fancyFonts">
                  {{font.fontDisplayName}} ({{font.copyAndPasteTitleText}})
                </option>
              </select>

              <div *ngIf="layerData?.meta?.is_title_font_changed"
                class="custom-control custom-checkbox custom-control-inline">
                <input type="checkbox" class="custom-control-input" id="mixTitleFirstLetter"
                  (change)="textFirstLetterChanged($event, 'title')" [checked]="layerData?.meta?.fc_title_first_letter">
                <label class="custom-control-label" for="mixTitleFirstLetter">First letter</label>
              </div>
            </div>

            <div mwlTextInputHighlightContainer>
              <textarea mwlTextInputElement #videoTitle class="form-control bg-transparent border-secondary text-light"
                id="videoTitle" rows="1" [mentionConfig]="mentionConfig" [ngModel]="layerData?.meta?.title"
                (ngModelChange)="videoTitleChange($event)"></textarea>
              <mwl-text-input-highlight [tags]="highlightTag?.title" [textInputElement]="videoTitle">
              </mwl-text-input-highlight>
            </div>
          </div>

          <div class="form-group">
            <div class="d-flex align-items-center text-truncate mb-2">
              <label class="mr-3 mb-0" for="videoDesc">Description</label>

              <div class="custom-control custom-checkbox custom-control-inline">
                <input type="checkbox" class="custom-control-input" id="isMixDescEmpty"
                  (change)="isTextEmptyChange($event, 'desc')" [checked]="layerData?.meta?.is_desc_empty">
                <label class="custom-control-label" for="isMixDescEmpty">Empty</label>
              </div>

              <div class="custom-control custom-checkbox custom-control-inline">
                <input type="checkbox" class="custom-control-input" id="isMixDescUpper"
                  (change)="isTextUpperChange($event, 'desc')" [checked]="layerData?.meta?.is_desc_upper">
                <label class="custom-control-label" for="isMixDescUpper">UPPERCASE</label>
              </div>

              <div class="custom-control custom-checkbox custom-control-inline"
                *ngIf="layerData?.meta?.is_desc_upper && !layerData?.meta?.hasOwnProperty('desc_ucword')">
                <input type="checkbox" class="custom-control-input" id="mixDescCap"
                  (change)="textCapChange($event, 'desc')" [checked]="layerData?.meta?.hasOwnProperty('desc_ucfirst')">
                <label class="custom-control-label" for="mixDescCap">Uppercase Firsts</label>
              </div>

              <div class="custom-control custom-checkbox custom-control-inline"
                *ngIf="layerData?.meta?.is_desc_upper && !layerData?.meta?.hasOwnProperty('desc_ucfirst') && !layerData?.meta?.hasOwnProperty('desc_lowercase')">
                <input type="checkbox" class="custom-control-input" id="mixDescUpper"
                  (change)="textUpperChange($event, 'desc')" [checked]="layerData?.meta?.hasOwnProperty('desc_ucword')">
                <label class="custom-control-label" for="mixDescUpper">UPPERCASE WORDS</label>
              </div>

              <div class="custom-control custom-checkbox custom-control-inline"
                *ngIf="!layerData?.meta?.hasOwnProperty('desc_ucword')">
                <input type="checkbox" class="custom-control-input" id="mixDescLower"
                  (change)="textLowerChange($event, 'desc')"
                  [checked]="layerData?.meta?.hasOwnProperty('desc_lowercase')">
                <label class="custom-control-label" for="mixDescLower">lowercase</label>
              </div>

              <div class="custom-control custom-checkbox custom-control-inline">
                <input type="checkbox" class="custom-control-input" id="isMixDescFontChanged"
                  (change)="isTextFontChanged($event, 'desc')" [checked]="layerData?.meta?.is_desc_font_changed">
                <label class="custom-control-label" for="isMixDescFontChanged">Font</label>
              </div>

              <select *ngIf="layerData?.meta?.is_desc_font_changed" (change)="textFontChanged($event, 'desc')"
                class="form-control bg-dark border-secondary text-light mr-3">
                <option value="">Choose a font</option>
                <option [value]="font.fontName" [selected]="layerData?.meta?.fc_desc_font_name == font.fontName"
                  *ngFor="let font of editorService.fancyFonts">
                  {{font.fontDisplayName}} ({{font.copyAndPasteTitleText}})
                </option>
              </select>

              <div *ngIf="layerData?.meta?.is_desc_font_changed"
                class="custom-control custom-checkbox custom-control-inline">
                <input type="checkbox" class="custom-control-input" id="mixDescFirstLetter"
                  (change)="textFirstLetterChanged($event, 'desc')" [checked]="layerData?.meta?.fc_desc_first_letter">
                <label class="custom-control-label" for="mixDescFirstLetter">First letter</label>
              </div>
            </div>

            <div mwlTextInputHighlightContainer>
              <textarea mwlTextInputElement #videoDesc class="form-control bg-transparent border-secondary text-light"
                id="videoDesc" rows="5" [mentionConfig]="mentionConfig" [ngModel]="layerData?.meta?.description"
                (ngModelChange)="videoDescChange($event)" (keypress)="videoDescValidate($event)"></textarea>
              <mwl-text-input-highlight [tags]="highlightTag?.description" [textInputElement]="videoDesc">
              </mwl-text-input-highlight>
            </div>
          </div>

          <div class="form-group">
            <div class="d-flex align-items-center text-truncate mb-2">
              <label class="mr-3 mb-0" for="videoTags">Tags</label>

              <div class="custom-control custom-checkbox custom-control-inline">
                <input type="checkbox" class="custom-control-input" id="isMixTagsEmpty"
                  (change)="isTextEmptyChange($event, 'tags')" [checked]="layerData?.meta?.is_tags_empty">
                <label class="custom-control-label" for="isMixTagsEmpty">Empty</label>
              </div>
            </div>

            <div mwlTextInputHighlightContainer>
              <textarea mwlTextInputElement #videoTags class="form-control bg-transparent border-secondary text-light"
                id="videoTags" rows="5" [mentionConfig]="mentionConfig" [ngModel]="layerData?.meta?.tags"
                (ngModelChange)="videoTagsChange($event)"></textarea>
              <mwl-text-input-highlight [tags]="highlightTag?.tags" [textInputElement]="videoTags">
              </mwl-text-input-highlight>
            </div>
          </div>

          <div class="custom-control custom-checkbox form-group">
            <input type="checkbox" class="custom-control-input" id="mixAutoUpload"
              [(ngModel)]="layerData.meta.auto_upload">
            <label class="custom-control-label" for="mixAutoUpload">Auto upload</label>
          </div>

          <div class="form-group border border-black rounded p-3" *ngIf="layerData?.meta?.auto_upload">
            <div class="form-group">
              <div class="custom-control custom-checkbox custom-control-inline">
                <input type="checkbox" class="custom-control-input" id="mixSchedule" (change)="scheduleChange($event)"
                  [checked]="layerData?.meta?.schedule != null">
                <label class="custom-control-label" for="mixSchedule">Schedules</label>
              </div>

              <div class="custom-control custom-checkbox custom-control-inline">
                <input type="checkbox" class="custom-control-input" id="publicX"
                  [(ngModel)]="layerData.meta.public_x">
                <label class="custom-control-label" for="publicX" title="Don't publish or notify subscribers">Public X</label>
              </div>

              <div class="custom-control custom-checkbox custom-control-inline">
                <input type="checkbox" class="custom-control-input" id="mixUpdateTitle"
                  [(ngModel)]="layerData.meta.boommix_update_title">
                <label class="custom-control-label" for="mixUpdateTitle">Update title</label>
              </div>
            </div>

            <div *ngIf="layerData?.meta?.schedule != null">
              <div class="form-row mb-3" *ngFor="let item of layerData?.meta?.schedule; let i = index">
                <div class="col-md">
                  <mat-form-field appearance="fill">
                    <mat-label>Choose a date</mat-label>
                    <input matInput [matDatepicker]="picker" [value]="bindDate(item?.date)"
                      (dateChange)="dateScheduleChange($event, i)">
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>
                </div>

                <div class="col-md">
                  <div class="d-flex align-items-center bg-dark border border-secondary rounded h-100 px-2">
                    <select class="custom-select bg-dark border-0 text-light" (change)="seqTypeChange($event, i)">
                      <option value="">Choose a seq</option>
                      <option [selected]="item?.seq_type == 'daily'" value="daily">Daily</option>
                      <option [selected]="item?.seq_type == 'weekly'" value="weekly">Weekly</option>
                      <option [selected]="item?.seq_type == 'monthly'" value="monthly">Monthly</option>
                    </select>

                    <input type="text" class="form-control bg-dark border-secondary text-light"
                      [ngClass]="{ 'd-none' : item?.seq_type == 'daily' }" [ngModel]="item?.seq_data" placeholder="2,3-5"
                      (ngModelChange)="seqDataChange($event, i)" (keypress)="validSeqData($event, item?.seq_type)"
                      data-toggle="tooltip" data-placement="bottom" title="Weekly (1-7): 1 = Sunday">
                  </div>
                </div>

                <div class="col-md">
                  <mat-form-field appearance="fill" class="w-100">
                    <mat-label>Choose time(s)</mat-label>
                    <mat-select (ngModelChange)="timeScheduleChange($event, i)" [ngModel]="layerData?.meta?.schedule[i]?.time_random" [compareWith]="editorService.matCompareWith" multiple>
                      <mat-select-trigger class="text-light">
                        {{ layerData?.meta?.schedule[i]?.time_random?.length ? layerData?.meta?.schedule[i]?.time_random[0] : '' }}
                        <span *ngIf="layerData?.meta?.schedule[i]?.time_random?.length > 1">
                          (+{{ layerData?.meta?.schedule[i]?.time_random.length - 1 }}
                          {{ layerData?.meta?.schedule[i]?.time_random.length == 2 ? 'other' : 'others' }})
                        </span>
                      </mat-select-trigger>

                      <mat-optgroup>
                        <mat-form-field class="w-100">
                          <input matInput placeholder="Search" #timeRangeFilter (keydown)="$event.stopPropagation()">
                        </mat-form-field>
                      </mat-optgroup>

                      <mat-option
                        *ngFor="let t of editorService.getTimeRanges()" [value]="t"
                        [ngClass]="{ 'd-none': !t?.toLowerCase()?.includes(timeRangeFilter.value.toLowerCase()) }">
                        {{ t }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <div class="col-md">
                  <select class="custom-select bg-dark border-secondary text-light h-100"
                    (change)="tzScheduleChange($event, i)" disabled>
                    <option>Choose a time zone</option>
                    <option *ngFor="let z of editorService.timeZones" [selected]="item?.time_zone == z.offset"
                      [value]="z.offset">
                      {{ z.country }}</option>
                  </select>
                </div>

                <!-- <div class="col-md-1 d-flex align-items-center p-0">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                    class="bi bi-trash text-danger c-pointer" viewBox="0 0 16 16" (click)="deleteSchedule(i)">
                    <path
                      d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                    <path fill-rule="evenodd"
                      d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z" />
                  </svg>

                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                    class="bi bi-plus c-pointer" viewBox="0 0 16 16" (click)="addSchedule(i)">
                    <path
                      d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                  </svg>
                </div> -->
              </div>

              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" id="mixPremiere"
                  [(ngModel)]="layerData.meta.is_premiere">
                <label class="custom-control-label" for="mixPremiere">Set as Premiere</label>
              </div>
            </div>

            <div class="mt-3">
              <mat-form-field appearance="fill">
                <mat-label>Video location</mat-label>
                <mat-select [compareWith]="editorService.matCompareWith" [(ngModel)]="layerData.meta.location">
                  <mat-select-trigger class="text-light">{{ layerData.meta?.location || 'United States' }}</mat-select-trigger>

                  <mat-optgroup>
                    <mat-form-field class="w-100">
                      <input matInput placeholder="Search" #locFilter (keydown)="$event.stopPropagation()">
                    </mat-form-field>
                  </mat-optgroup>

                  <mat-option value="None">None</mat-option>
                  <mat-option *ngFor="let item of editorService.videoLocations" [value]="item"
                    [ngClass]="{ 'd-none': !item?.toLowerCase()?.includes(locFilter.value.toLowerCase()) }">
                    {{ item }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </ng-container>
      </div>

      <div class="modal-footer">
        <div *ngIf="layerData?.music_data?.length && getMusicDataSummary() as summary" class="mr-auto text-warning tracks-summary">
          {{ summary.total }} Tracks
          (<span *ngFor="let item of summary.musicTypes | keyvalue; let last = last">{{ item.key }}: {{ item.value }}<ng-container *ngIf="!last">, </ng-container></span>)
          - {{ totalTimestamp() }}
        </div>
        <button (click)="resetMusicData()" type="button" class="btn btn-secondary" title="Reset all music data">Reset</button>
        <button (click)="layerData.text_list_config = '%song_name% - %artist_name%'" data-toggle="modal"
          data-target="#textListConfigModal" type="button" class="btn btn-info" title="Textlist config">Textlist</button>
        <button (click)="genTimestamp()" data-toggle="modal" data-target="#timestampModal" type="button"
          class="btn btn-info">Timestamp</button>
        <button type="button" class="btn btn-primary" (click)="saveCompilation($event)">Save</button>
      </div>
    </div>
  </div>
</div>

<div id="mixLyricModal" class="modal fade">
  <div class="modal-dialog modal-dialog-scrollable modal-lg">
    <div class="modal-content bg-dark text-light">
      <div class="modal-header">
        <h5 class="modal-title">Mix lyric</h5>
        <button type="button" class="close" data-dismiss="modal">
          <span>&times;</span>
        </button>
      </div>

      <div class="modal-body">
        <app-music-picker #musicPicker mode="mix_lyric" [target]="layerData" [boomGenres]="boomGenres"
          [isPortrait]="isPortrait" [validationErrors]="musicValidationErrors"></app-music-picker>

        <ng-container *ngIf="layerData.hasOwnProperty('meta')">
          <div class="form-group">
            <div class="d-flex align-items-center text-truncate mb-2">
              <label class="mr-3 mb-0" for="videoTitle">Title</label>

              <div class="custom-control custom-checkbox custom-control-inline">
                <input type="checkbox" class="custom-control-input" id="isMixTitleUpper"
                  (change)="isTextUpperChange($event, 'title')" [checked]="layerData?.meta?.is_title_upper">
                <label class="custom-control-label" for="isMixTitleUpper">UPPERCASE</label>
              </div>

              <div class="custom-control custom-checkbox custom-control-inline"
                *ngIf="layerData?.meta?.is_title_upper && !layerData?.meta?.hasOwnProperty('title_ucword')">
                <input type="checkbox" class="custom-control-input" id="mixTitleCap"
                  (change)="textCapChange($event, 'title')" [checked]="layerData?.meta?.hasOwnProperty('title_ucfirst')">
                <label class="custom-control-label" for="mixTitleCap">Uppercase Firsts</label>
              </div>

              <div class="custom-control custom-checkbox custom-control-inline"
                *ngIf="layerData?.meta?.is_title_upper && !layerData?.meta?.hasOwnProperty('title_ucfirst') && !layerData?.meta?.hasOwnProperty('title_lowercase')">
                <input type="checkbox" class="custom-control-input" id="mixTitleUpper"
                  (change)="textUpperChange($event, 'title')" [checked]="layerData?.meta?.hasOwnProperty('title_ucword')">
                <label class="custom-control-label" for="mixTitleUpper">UPPERCASE WORDS</label>
              </div>

              <div class="custom-control custom-checkbox custom-control-inline"
                *ngIf="!layerData?.meta?.hasOwnProperty('title_ucword')">
                <input type="checkbox" class="custom-control-input" id="mixTitleLower"
                  (change)="textLowerChange($event, 'title')"
                  [checked]="layerData?.meta?.hasOwnProperty('title_lowercase')">
                <label class="custom-control-label" for="mixTitleLower">lowercase</label>
              </div>

              <div class="custom-control custom-checkbox custom-control-inline">
                <input type="checkbox" class="custom-control-input" id="isMixTitleFontChanged"
                  (change)="isTextFontChanged($event, 'title')" [checked]="layerData?.meta?.is_title_font_changed">
                <label class="custom-control-label" for="isMixTitleFontChanged">Font</label>
              </div>

              <select *ngIf="layerData?.meta?.is_title_font_changed" (change)="textFontChanged($event, 'title')"
                class="form-control bg-dark border-secondary text-light mr-3">
                <option value="">Choose a font</option>
                <option [value]="font.fontName" [selected]="layerData?.meta?.fc_title_font_name == font.fontName"
                  *ngFor="let font of editorService.fancyFonts">
                  {{font.fontDisplayName}} ({{font.copyAndPasteTitleText}})
                </option>
              </select>

              <div *ngIf="layerData?.meta?.is_title_font_changed"
                class="custom-control custom-checkbox custom-control-inline">
                <input type="checkbox" class="custom-control-input" id="mixTitleFirstLetter"
                  (change)="textFirstLetterChanged($event, 'title')" [checked]="layerData?.meta?.fc_title_first_letter">
                <label class="custom-control-label" for="mixTitleFirstLetter">First letter</label>
              </div>
            </div>

            <div mwlTextInputHighlightContainer>
              <textarea mwlTextInputElement #videoTitle class="form-control bg-transparent border-secondary text-light"
                id="videoTitle" rows="1" [mentionConfig]="mentionConfig" [ngModel]="layerData?.meta?.title"
                (ngModelChange)="videoTitleChange($event)"></textarea>
              <mwl-text-input-highlight [tags]="highlightTag?.title" [textInputElement]="videoTitle">
              </mwl-text-input-highlight>
            </div>
          </div>

          <div class="form-group">
            <div class="d-flex align-items-center text-truncate mb-2">
              <label class="mr-3 mb-0" for="videoDesc">Description</label>

              <div class="custom-control custom-checkbox custom-control-inline">
                <input type="checkbox" class="custom-control-input" id="isMixDescEmpty"
                  (change)="isTextEmptyChange($event, 'desc')" [checked]="layerData?.meta?.is_desc_empty">
                <label class="custom-control-label" for="isMixDescEmpty">Empty</label>
              </div>

              <div class="custom-control custom-checkbox custom-control-inline">
                <input type="checkbox" class="custom-control-input" id="isMixDescUpper"
                  (change)="isTextUpperChange($event, 'desc')" [checked]="layerData?.meta?.is_desc_upper">
                <label class="custom-control-label" for="isMixDescUpper">UPPERCASE</label>
              </div>

              <div class="custom-control custom-checkbox custom-control-inline"
                *ngIf="layerData?.meta?.is_desc_upper && !layerData?.meta?.hasOwnProperty('desc_ucword')">
                <input type="checkbox" class="custom-control-input" id="mixDescCap"
                  (change)="textCapChange($event, 'desc')" [checked]="layerData?.meta?.hasOwnProperty('desc_ucfirst')">
                <label class="custom-control-label" for="mixDescCap">Uppercase Firsts</label>
              </div>

              <div class="custom-control custom-checkbox custom-control-inline"
                *ngIf="layerData?.meta?.is_desc_upper && !layerData?.meta?.hasOwnProperty('desc_ucfirst') && !layerData?.meta?.hasOwnProperty('desc_lowercase')">
                <input type="checkbox" class="custom-control-input" id="mixDescUpper"
                  (change)="textUpperChange($event, 'desc')" [checked]="layerData?.meta?.hasOwnProperty('desc_ucword')">
                <label class="custom-control-label" for="mixDescUpper">UPPERCASE WORDS</label>
              </div>

              <div class="custom-control custom-checkbox custom-control-inline"
                *ngIf="!layerData?.meta?.hasOwnProperty('desc_ucword')">
                <input type="checkbox" class="custom-control-input" id="mixDescLower"
                  (change)="textLowerChange($event, 'desc')"
                  [checked]="layerData?.meta?.hasOwnProperty('desc_lowercase')">
                <label class="custom-control-label" for="mixDescLower">lowercase</label>
              </div>

              <div class="custom-control custom-checkbox custom-control-inline">
                <input type="checkbox" class="custom-control-input" id="isMixDescFontChanged"
                  (change)="isTextFontChanged($event, 'desc')" [checked]="layerData?.meta?.is_desc_font_changed">
                <label class="custom-control-label" for="isMixDescFontChanged">Font</label>
              </div>

              <select *ngIf="layerData?.meta?.is_desc_font_changed" (change)="textFontChanged($event, 'desc')"
                class="form-control bg-dark border-secondary text-light mr-3">
                <option value="">Choose a font</option>
                <option [value]="font.fontName" [selected]="layerData?.meta?.fc_desc_font_name == font.fontName"
                  *ngFor="let font of editorService.fancyFonts">
                  {{font.fontDisplayName}} ({{font.copyAndPasteTitleText}})
                </option>
              </select>

              <div *ngIf="layerData?.meta?.is_desc_font_changed"
                class="custom-control custom-checkbox custom-control-inline">
                <input type="checkbox" class="custom-control-input" id="mixDescFirstLetter"
                  (change)="textFirstLetterChanged($event, 'desc')" [checked]="layerData?.meta?.fc_desc_first_letter">
                <label class="custom-control-label" for="mixDescFirstLetter">First letter</label>
              </div>
            </div>

            <div mwlTextInputHighlightContainer>
              <textarea mwlTextInputElement #videoDesc class="form-control bg-transparent border-secondary text-light"
                id="videoDesc" rows="5" [mentionConfig]="mentionConfig" [ngModel]="layerData?.meta?.description"
                (ngModelChange)="videoDescChange($event)" (keypress)="videoDescValidate($event)"></textarea>
              <mwl-text-input-highlight [tags]="highlightTag?.description" [textInputElement]="videoDesc">
              </mwl-text-input-highlight>
            </div>
          </div>

          <div class="form-group">
            <div class="d-flex align-items-center text-truncate mb-2">
              <label class="mr-3 mb-0" for="videoTags">Tags</label>

              <div class="custom-control custom-checkbox custom-control-inline">
                <input type="checkbox" class="custom-control-input" id="isMixTagsEmpty"
                  (change)="isTextEmptyChange($event, 'tags')" [checked]="layerData?.meta?.is_tags_empty">
                <label class="custom-control-label" for="isMixTagsEmpty">Empty</label>
              </div>
            </div>

            <div mwlTextInputHighlightContainer>
              <textarea mwlTextInputElement #videoTags class="form-control bg-transparent border-secondary text-light"
                id="videoTags" rows="5" [mentionConfig]="mentionConfig" [ngModel]="layerData?.meta?.tags"
                (ngModelChange)="videoTagsChange($event)"></textarea>
              <mwl-text-input-highlight [tags]="highlightTag?.tags" [textInputElement]="videoTags">
              </mwl-text-input-highlight>
            </div>
          </div>

          <div class="custom-control custom-checkbox form-group">
            <input type="checkbox" class="custom-control-input" id="mixAutoUpload"
              [(ngModel)]="layerData.meta.auto_upload">
            <label class="custom-control-label" for="mixAutoUpload">Auto upload</label>
          </div>

          <div class="form-group border border-black rounded p-3" *ngIf="layerData?.meta?.auto_upload">
            <div class="form-group">
              <div class="custom-control custom-checkbox custom-control-inline">
                <input type="checkbox" class="custom-control-input" id="mixSchedule" (change)="scheduleChange($event)"
                  [checked]="layerData?.meta?.schedule != null">
                <label class="custom-control-label" for="mixSchedule">Schedules</label>
              </div>

              <div class="custom-control custom-checkbox custom-control-inline">
                <input type="checkbox" class="custom-control-input" id="mixUpdateTitle"
                  [(ngModel)]="layerData.meta.boommix_update_title">
                <label class="custom-control-label" for="mixUpdateTitle">Update title</label>
              </div>

              <div class="custom-control custom-checkbox custom-control-inline">
                <input type="checkbox" class="custom-control-input" id="publicX"
                  [(ngModel)]="layerData.meta.public_x">
                <label class="custom-control-label" for="publicX" title="Don't publish or notify subscribers">Public X</label>
              </div>
            </div>

            <div *ngIf="layerData?.meta?.schedule != null">
              <div class="form-row mb-3" *ngFor="let item of layerData?.meta?.schedule; let i = index">
                <div class="col-md">
                  <mat-form-field appearance="fill">
                    <mat-label>Choose a date</mat-label>
                    <input matInput [matDatepicker]="picker" [value]="bindDate(item?.date)"
                      (dateChange)="dateScheduleChange($event, i)">
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>
                </div>

                <div class="col-md">
                  <div class="d-flex align-items-center bg-dark border border-secondary rounded h-100 px-2">
                    <select class="custom-select bg-dark border-0 text-light" (change)="seqTypeChange($event, i)">
                      <option value="">Choose a seq</option>
                      <option [selected]="item?.seq_type == 'daily'" value="daily">Daily</option>
                      <option [selected]="item?.seq_type == 'weekly'" value="weekly">Weekly</option>
                      <option [selected]="item?.seq_type == 'monthly'" value="monthly">Monthly</option>
                    </select>

                    <input type="text" class="form-control bg-dark border-secondary text-light"
                      [ngClass]="{ 'd-none' : item?.seq_type == 'daily' }" [ngModel]="item?.seq_data" placeholder="2,3-5"
                      (ngModelChange)="seqDataChange($event, i)" (keypress)="validSeqData($event, item?.seq_type)"
                      data-toggle="tooltip" data-placement="bottom" title="Weekly (1-7): 1 = Sunday">
                  </div>
                </div>

                <div class="col-md">
                  <mat-form-field appearance="fill" class="w-100">
                    <mat-label>Choose time(s)</mat-label>
                    <mat-select (ngModelChange)="timeScheduleChange($event, i)" [ngModel]="layerData?.meta?.schedule[i]?.time_random" [compareWith]="editorService.matCompareWith" multiple>
                      <mat-select-trigger class="text-light">
                        {{ layerData?.meta?.schedule[i]?.time_random?.length ? layerData?.meta?.schedule[i]?.time_random[0] : '' }}
                        <span *ngIf="layerData?.meta?.schedule[i]?.time_random?.length > 1">
                          (+{{ layerData?.meta?.schedule[i]?.time_random.length - 1 }}
                          {{ layerData?.meta?.schedule[i]?.time_random.length == 2 ? 'other' : 'others' }})
                        </span>
                      </mat-select-trigger>

                      <mat-optgroup>
                        <mat-form-field class="w-100">
                          <input matInput placeholder="Search" #timeRangeFilter (keydown)="$event.stopPropagation()">
                        </mat-form-field>
                      </mat-optgroup>

                      <mat-option
                        *ngFor="let t of editorService.getTimeRanges()" [value]="t"
                        [ngClass]="{ 'd-none': !t?.toLowerCase()?.includes(timeRangeFilter.value.toLowerCase()) }">
                        {{ t }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <div class="col-md">
                  <select class="custom-select bg-dark border-secondary text-light h-100"
                    (change)="tzScheduleChange($event, i)" disabled>
                    <option>Choose a time zone</option>
                    <option *ngFor="let z of editorService.timeZones" [selected]="item?.time_zone == z.offset"
                      [value]="z.offset">
                      {{ z.country }}</option>
                  </select>
                </div>

                <!-- <div class="col-md-1 d-flex align-items-center p-0">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                    class="bi bi-trash text-danger c-pointer" viewBox="0 0 16 16" (click)="deleteSchedule(i)">
                    <path
                      d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                    <path fill-rule="evenodd"
                      d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z" />
                  </svg>

                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                    class="bi bi-plus c-pointer" viewBox="0 0 16 16" (click)="addSchedule(i)">
                    <path
                      d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                  </svg>
                </div> -->
              </div>

              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" id="mixPremiere"
                  [(ngModel)]="layerData.meta.is_premiere">
                <label class="custom-control-label" for="mixPremiere">Set as Premiere</label>
              </div>
            </div>

            <div class="mt-3">
              <mat-form-field appearance="fill">
                <mat-label>Video location</mat-label>
                <mat-select [compareWith]="editorService.matCompareWith" [(ngModel)]="layerData.meta.location">
                  <mat-select-trigger class="text-light">{{ layerData.meta?.location || 'United States' }}</mat-select-trigger>

                  <mat-optgroup>
                    <mat-form-field class="w-100">
                      <input matInput placeholder="Search" #locFilter (keydown)="$event.stopPropagation()">
                    </mat-form-field>
                  </mat-optgroup>

                  <mat-option value="None">None</mat-option>
                  <mat-option *ngFor="let item of editorService.videoLocations" [value]="item"
                    [ngClass]="{ 'd-none': !item?.toLowerCase()?.includes(locFilter.value.toLowerCase()) }">
                    {{ item }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>

          <div class="custom-control custom-checkbox form-group">
            <input type="checkbox" class="custom-control-input" id="mixAutoComment"
              [(ngModel)]="layerData.meta.auto_comment">
            <label class="custom-control-label" for="mixAutoComment">Auto comment</label>
          </div>

          <div class="form-group border border-black rounded p-3" *ngIf="layerData?.meta?.auto_comment">
            <div class="form-group">
              <div class="d-flex align-items-center text-truncate mb-2">
                <label class="mr-3 mb-0" for="comment">Comment</label>

                <div class="custom-control custom-checkbox custom-control-inline">
                  <input type="checkbox" class="custom-control-input" id="isMixCommentUpper"
                    (change)="isTextUpperChange($event, 'comment')" [checked]="layerData?.meta?.is_comment_upper">
                  <label class="custom-control-label" for="isMixCommentUpper">UPPERCASE</label>
                </div>

                <div class="custom-control custom-checkbox custom-control-inline"
                  *ngIf="layerData?.meta?.is_comment_upper && !layerData?.meta?.hasOwnProperty('comment_ucword')">
                  <input type="checkbox" class="custom-control-input" id="mixCommentCap"
                    (change)="textCapChange($event, 'comment')"
                    [checked]="layerData?.meta?.hasOwnProperty('comment_ucfirst')">
                  <label class="custom-control-label" for="mixCommentCap">Uppercase Firsts</label>
                </div>

                <div class="custom-control custom-checkbox custom-control-inline"
                  *ngIf="layerData?.meta?.is_comment_upper && !layerData?.meta?.hasOwnProperty('comment_ucfirst') && !layerData?.meta?.hasOwnProperty('comment_lowercase')">
                  <input type="checkbox" class="custom-control-input" id="mixCommentUpper"
                    (change)="textUpperChange($event, 'comment')"
                    [checked]="layerData?.meta?.hasOwnProperty('comment_ucword')">
                  <label class="custom-control-label" for="mixCommentUpper">UPPERCASE WORDS</label>
                </div>

                <div class="custom-control custom-checkbox custom-control-inline"
                  *ngIf="!layerData?.meta?.hasOwnProperty('comment_ucword')">
                  <input type="checkbox" class="custom-control-input" id="mixCommentLower"
                    (change)="textLowerChange($event, 'comment')"
                    [checked]="layerData?.meta?.hasOwnProperty('comment_lowercase')">
                  <label class="custom-control-label" for="mixCommentLower">lowercase</label>
                </div>

                <div class="custom-control custom-checkbox custom-control-inline">
                  <input type="checkbox" class="custom-control-input" id="isMixCommentFontChanged"
                    (change)="isTextFontChanged($event, 'comment')" [checked]="layerData?.meta?.is_comment_font_changed">
                  <label class="custom-control-label" for="isMixCommentFontChanged">Font</label>
                </div>

                <select *ngIf="layerData?.meta?.is_comment_font_changed" (change)="textFontChanged($event, 'comment')"
                  class="form-control bg-dark border-secondary text-light mr-3">
                  <option value="">Choose a font</option>
                  <option [value]="font.fontName" [selected]="layerData?.meta?.fc_comment_font_name == font.fontName"
                    *ngFor="let font of editorService.fancyFonts">
                    {{font.fontDisplayName}} ({{font.copyAndPasteTitleText}})
                  </option>
                </select>

                <div *ngIf="layerData?.meta?.is_comment_font_changed"
                  class="custom-control custom-checkbox custom-control-inline">
                  <input type="checkbox" class="custom-control-input" id="mixCommentFirstLetter"
                    (change)="textFirstLetterChanged($event, 'comment')"
                    [checked]="layerData?.meta?.fc_comment_first_letter">
                  <label class="custom-control-label" for="mixCommentFirstLetter">First letter</label>
                </div>
              </div>

              <div mwlTextInputHighlightContainer>
                <textarea mwlTextInputElement #comment class="form-control bg-transparent border-secondary text-light"
                  id="comment" rows="5" [mentionConfig]="mentionConfig" [ngModel]="layerData?.meta?.comment"
                  (ngModelChange)="commentChange($event)"></textarea>
                <mwl-text-input-highlight [tags]="highlightTag?.comment" [textInputElement]="comment">
                </mwl-text-input-highlight>
              </div>
            </div>

            <div class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input" id="mixPinComment"
                [(ngModel)]="layerData.meta.is_pin_comment">
              <label class="custom-control-label" for="mixPinComment">Pin comment</label>
            </div>
          </div>

          <div class="custom-control custom-checkbox form-group">
            <input type="checkbox" class="custom-control-input" id="mixAutoCard" [(ngModel)]="autoCardEnabled">
            <label class="custom-control-label" for="mixAutoCard">Auto cards</label>
          </div>

          <div *ngIf="layerData?.meta?.auto_card" class="form-group border border-black rounded p-3">
            <div class="form-group">
              <label for="mixAutoCardVideoId">Video ID</label>
              <input [(ngModel)]="layerData.meta.auto_card.target_video_id"
                (change)="layerData.meta.auto_card.target_video_id = parseYoutubeId($event)" type="text"
                class="form-control bg-dark border-secondary text-light" id="mixAutoCardVideoId">
            </div>
          </div>

          <div class="custom-control custom-checkbox form-group">
            <input type="checkbox" class="custom-control-input" id="mixAutoEndscreen"
              [(ngModel)]="autoEndscreenEnabled">
            <label class="custom-control-label" for="mixAutoEndscreen">Auto endscreen</label>
          </div>

          <div *ngIf="layerData?.meta?.auto_endscreen" class="form-group border border-black rounded p-3">
            <div class="row mb-3">
              <div class="col-md-2">
                <div class="border border-primary rounded d-flex align-items-center justify-content-center"
                  style="aspect-ratio:16/9;padding:1rem;">
                  <div class="bg-secondary rounded" style="width:64px;height:36px;"></div>
                </div>
              </div>
            </div>

            <div class="form-group">
              <label for="mixAutoEndscreenVideoId">Video ID</label>
              <input [(ngModel)]="layerData.meta.auto_endscreen.target_video_id"
                (change)="layerData.meta.auto_endscreen.target_video_id = parseYoutubeId($event)" type="text"
                class="form-control bg-dark border-secondary text-light" id="mixAutoEndscreenVideoId">
            </div>
          </div>
        </ng-container>
      </div>

      <div class="modal-footer">
        <div *ngIf="layerData?.mix_data?.length && getMusicDataSummary() as summary" class="mr-auto text-warning tracks-summary">
          {{ summary.total }} Tracks
          (<span *ngFor="let item of summary.musicTypes | keyvalue; let last = last">{{ item.key }}: {{ item.value }}<ng-container *ngIf="!last">, </ng-container></span>)
          - {{ totalTimestamp() }}
        </div>
        <button (click)="resetMusicData()" type="button" class="btn btn-secondary" title="Reset all music data">Reset</button>
        <button (click)="layerData.text_list_config = '%song_name% - %artist_name%'" data-toggle="modal"
          data-target="#textListConfigModal" type="button" class="btn btn-info" title="Textlist config">Textlist</button>
        <button (click)="genTimestamp()" data-toggle="modal" data-target="#timestampModal" type="button"
          class="btn btn-info">Timestamp</button>
        <button (click)="saveMixLyric($event)" type="button" class="btn btn-primary">Save</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="timestampModal" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content bg-gray-700 text-light">
      <div class="modal-header">
        <h5 class="modal-title">Timestamp</h5>
        <button type="button" class="close" data-dismiss="modal">
          <span>&times;</span>
        </button>
      </div>

      <div class="modal-body">
        <div class="d-flex align-items-center">
          <textarea #timestampCopy class="form-control bg-gray-700 border-secondary text-light" rows="5"
            [ngModel]="musicTimestamp"></textarea>
          <div class="d-flex flex-column">
            <button type="button" class="btn btn-link" [ngxClipboard]="timestampCopy">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-clipboard"
                viewBox="0 0 16 16" data-toggle="tooltip" data-placement="top" title="Copy">
                <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z" />
                <path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z" />
              </svg>
            </button>
            <button (click)="genTimestampSRT()" type="button" class="btn btn-link" >
              <svg data-toggle="tooltip" data-placement="top" title="Download captions" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-file-earmark-arrow-down" viewBox="0 0 16 16">
                <path d="M8.5 6.5a.5.5 0 0 0-1 0v3.793L6.354 9.146a.5.5 0 1 0-.708.708l2 2a.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0-.708-.708L8.5 10.293z"/>
                <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z"/>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="textListConfigModal" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content bg-gray-700 text-light">
      <div class="modal-header">
        <h5 class="modal-title">Textlist config</h5>
        <button type="button" class="close" data-dismiss="modal">
          <span>&times;</span>
        </button>
      </div>

      <div class="modal-body">
        <div class="mb-2">Allow variables: <span class="badge badge-pill badge-info">%song_name%</span>,
          <span class="badge badge-pill badge-info">%artist_name%</span>
        </div>
        <textarea class="form-control bg-gray-700 border-secondary text-light" rows="2"
          [(ngModel)]="layerData.text_list_config"></textarea>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="hubModal">
  <div class="modal-dialog modal-dialog-scrollable modal-xl">
    <div class="modal-content bg-dark text-light">
      <div class="modal-header">
        <h5 class="modal-title">Hub</h5>
        <button type="button" class="close" data-dismiss="modal">
          <span>&times;</span>
        </button>
      </div>

      <div class="modal-body">
        <div
          *ngIf="controlType == 'lyric' || controlType == 'compilation' || controlType == 'mix_lyric' || controlType.includes('collection:music')">
          <ul class="nav nav-pills" id="hubTab" role="tablist">
            <li class="nav-item" role="presentation">
              <a class="nav-link active" data-toggle="tab" href="#recommend" role="tab"
                (click)="recommendClick()">Recommend</a>
            </li>
            <li class="nav-item" role="presentation">
              <a class="nav-link" data-toggle="tab" href="#radio" role="tab" (click)="radioClick()">Radio</a>
            </li>
            <li class="nav-item" role="presentation">
              <a class="nav-link" data-toggle="tab" href="#playlist" role="tab" (click)="playlistClick(3)">
                Spotify</a>
            </li>
            <li class="nav-item" role="presentation">
              <a class="nav-link" data-toggle="tab" href="#playlist" role="tab" (click)="playlistClick(4)">
                Soundcloud
              </a>
            </li>
            <li class="nav-item" role="presentation">
              <a class="nav-link" data-toggle="tab" href="#playlist" role="tab" (click)="playlistClick(5)">
                Drive
              </a>
            </li>
            <li class="nav-item" role="presentation">
              <a class="nav-link" data-toggle="tab" href="#playlist" role="tab" (click)="playlistClick(6)">Deezer</a>
            </li>
            <li class="nav-item" role="presentation">
              <a class="nav-link" data-toggle="tab" href="#boom" role="tab" (click)="playlistClick(7)">Boom DB</a>
            </li>
            <li class="nav-item" role="presentation">
              <a class="nav-link" data-toggle="tab" href="#boomX" role="tab" (click)="playlistClick(8)">Boom X</a>
            </li>
          </ul>

          <div class="tab-content mt-3" id="hubTabContent">
            <div class="tab-pane fade show active" id="recommend" role="tabpanel">
              <div class="form-group">
                <label>Market</label>
                <select class="custom-select bg-dark border-secondary text-light" [(ngModel)]="sourceData.market">
                  <option [selected]="sourceData?.market == 'US'" value="US">US</option>
                  <option [selected]="sourceData?.market == 'GB'" value="GB">UK</option>
                </select>
              </div>

              <div class="custom-control custom-checkbox">
                <input type="checkbox" id="genres" class="custom-control-input"
                  (change)="chkRecommendChange($event, 'genres')" [checked]="sourceData.hasOwnProperty('genres')">
                <label class="custom-control-label text-warning" for="genres">Genres</label>
              </div>
              <div class="my-3" *ngIf="sourceData.hasOwnProperty('genres')">
                <div class="form-row">
                  <mat-form-field appearance="fill" class="col-md-6">
                    <mat-label>Choose genres</mat-label>
                    <mat-select [compareWith]="editorService.matCompareWith" [ngModel]="sourceData?.genres"
                      (ngModelChange)="genreChange($event)" multiple>
                      <mat-select-trigger class="text-light">
                        {{ sourceData?.genres ? sourceData?.genres[0] : '' }}
                        <span *ngIf="sourceData?.genres?.length > 1">
                          (+{{ sourceData?.genres.length - 1 }}
                          {{ sourceData?.genres.length == 2 ? 'other' : 'others' }})
                        </span>
                      </mat-select-trigger>
                      <mat-optgroup>
                        <mat-form-field class="w-100">
                          <input matInput placeholder="Search" #genreFilter (keydown)="$event.stopPropagation()">
                        </mat-form-field>
                      </mat-optgroup>
                      <mat-option *ngFor="let g of genreList" [value]="g"
                        [ngClass]="{ 'd-none': !g.toLowerCase().includes(genreFilter.value.toLowerCase()) }">
                        {{ g }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>

              <div class="custom-control custom-checkbox">
                <input type="checkbox" id="artists" class="custom-control-input"
                  (change)="chkRecommendChange($event, 'artists')" [checked]="sourceData.hasOwnProperty('artists')">
                <label class="custom-control-label text-warning" for="artists">Artists</label>
              </div>
              <div class="form-group" *ngIf="sourceData.hasOwnProperty('artists')">
                <label for="artistText">Artist links</label>
                <textarea class="form-control bg-dark border-secondary text-light" id="artistText" rows="5"
                  placeholder="https://open.spotify.com/artist/5ILrArfIV0tMURcHJN8Q07"
                  [ngModel]="sourceData?.artists_text" (input)="artistTextChange($event)"></textarea>
              </div>

              <div class="custom-control custom-checkbox">
                <input type="checkbox" id="tracks" class="custom-control-input"
                  (change)="chkRecommendChange($event, 'tracks')" [checked]="sourceData.hasOwnProperty('tracks')">
                <label class="custom-control-label text-warning" for="tracks">Tracks</label>
              </div>
              <div class="form-group" *ngIf="sourceData.hasOwnProperty('tracks')">
                <label for="trackText">Track links</label>
                <textarea class="form-control bg-dark border-secondary text-light" id="trackText" rows="5"
                  placeholder="https://open.spotify.com/track/4w1lzcaoZ1IC2K5TwjalRP"
                  [ngModel]="sourceData?.tracks_text" (input)="trackTextChange($event)"></textarea>
              </div>

              <div class="custom-control custom-checkbox">
                <input type="checkbox" id="danceability" class="custom-control-input"
                  (change)="chkRecommendChange($event, 'danceability')"
                  [checked]="sourceData.hasOwnProperty('danceability')">
                <label class="custom-control-label" for="danceability">Danceability</label>
              </div>
              <div class="row my-3 d-flex align-items-end" *ngIf="sourceData.hasOwnProperty('danceability')">
                <div class="col-md-2">
                  <input type="number" class="form-control bg-dark border-secondary text-light"
                    [(ngModel)]="sliders.danceability.minValue">
                </div>
                <ngx-slider class="col-md" [(value)]="sliders.danceability.minValue"
                  [(highValue)]="sliders.danceability.maxValue" [options]="sliders?.danceability?.options"
                  (highValueChange)="sliderChange($event, 'danceability')">
                </ngx-slider>
                <div class="col-md-2">
                  <input type="number" class="form-control bg-dark border-secondary text-light"
                    [(ngModel)]="sliders.danceability.maxValue">
                </div>
              </div>

              <div class="custom-control custom-checkbox">
                <input type="checkbox" id="valence" class="custom-control-input"
                  (change)="chkRecommendChange($event, 'valence')" [checked]="sourceData.hasOwnProperty('valence')">
                <label class="custom-control-label" for="valence">Mood</label>
              </div>
              <div class="row my-3 d-flex align-items-end" *ngIf="sourceData.hasOwnProperty('valence')">
                <div class="col-md-2">
                  <input type="number" class="form-control bg-dark border-secondary text-light"
                    [(ngModel)]="sliders.valence.minValue">
                </div>
                <ngx-slider class="col-md" [(value)]="sliders.valence.minValue" [(highValue)]="sliders.valence.maxValue"
                  [options]="sliders?.valence?.options" (highValueChange)="sliderChange($event, 'valence')">
                </ngx-slider>
                <div class="col-md-2">
                  <input type="number" class="form-control bg-dark border-secondary text-light"
                    [(ngModel)]="sliders.valence.maxValue">
                </div>
              </div>

              <div class="custom-control custom-checkbox">
                <input type="checkbox" id="energy" class="custom-control-input"
                  (change)="chkRecommendChange($event, 'energy')" [checked]="sourceData.hasOwnProperty('energy')">
                <label class="custom-control-label" for="energy">Energy</label>
              </div>
              <div class="row my-3 d-flex align-items-end" *ngIf="sourceData.hasOwnProperty('energy')">
                <div class="col-md-2">
                  <input type="number" class="form-control bg-dark border-secondary text-light"
                    [(ngModel)]="sliders.energy.minValue">
                </div>
                <ngx-slider class="col-md" [(value)]="sliders.energy.minValue" [(highValue)]="sliders.energy.maxValue"
                  [options]="sliders?.energy?.options" (highValueChange)="sliderChange($event, 'energy')">
                </ngx-slider>
                <div class="col-md-2">
                  <input type="number" class="form-control bg-dark border-secondary text-light"
                    [(ngModel)]="sliders.energy.maxValue">
                </div>
              </div>

              <div class="custom-control custom-checkbox">
                <input type="checkbox" id="speechiness" class="custom-control-input"
                  (change)="chkRecommendChange($event, 'speechiness')"
                  [checked]="sourceData.hasOwnProperty('speechiness')">
                <label class="custom-control-label" for="speechiness">Speechiness</label>
              </div>
              <div class="row my-3 d-flex align-items-end" *ngIf="sourceData.hasOwnProperty('speechiness')">
                <div class="col-md-2">
                  <input type="number" class="form-control bg-dark border-secondary text-light"
                    [(ngModel)]="sliders.speechiness.minValue">
                </div>
                <ngx-slider class="col-md" [(value)]="sliders.speechiness.minValue"
                  [(highValue)]="sliders.speechiness.maxValue" [options]="sliders?.speechiness?.options"
                  (highValueChange)="sliderChange($event, 'speechiness')">
                </ngx-slider>
                <div class="col-md-2">
                  <input type="number" class="form-control bg-dark border-secondary text-light"
                    [(ngModel)]="sliders.speechiness.maxValue">
                </div>
              </div>

              <div class="custom-control custom-checkbox">
                <input type="checkbox" id="instrumentalness" class="custom-control-input"
                  (change)="chkRecommendChange($event, 'instrumentalness')"
                  [checked]="sourceData.hasOwnProperty('instrumentalness')">
                <label class="custom-control-label" for="instrumentalness">Instrumentalness</label>
              </div>
              <div class="row my-3 d-flex align-items-end" *ngIf="sourceData.hasOwnProperty('instrumentalness')">
                <div class="col-md-2">
                  <input type="number" class="form-control bg-dark border-secondary text-light"
                    [(ngModel)]="sliders.instrumentalness.minValue">
                </div>
                <ngx-slider class="col-md" [(value)]="sliders.instrumentalness.minValue"
                  [(highValue)]="sliders.instrumentalness.maxValue" [options]="sliders?.instrumentalness?.options"
                  (highValueChange)="sliderChange($event, 'instrumentalness')">
                </ngx-slider>
                <div class="col-md-2">
                  <input type="number" class="form-control bg-dark border-secondary text-light"
                    [(ngModel)]="sliders.instrumentalness.maxValue">
                </div>
              </div>

              <div class="custom-control custom-checkbox">
                <input type="checkbox" id="acousticness" class="custom-control-input"
                  (change)="chkRecommendChange($event, 'acousticness')"
                  [checked]="sourceData.hasOwnProperty('acousticness')">
                <label class="custom-control-label" for="acousticness">Acousticness</label>
              </div>
              <div class="row my-3 d-flex align-items-end" *ngIf="sourceData.hasOwnProperty('acousticness')">
                <div class="col-md-2">
                  <input type="number" class="form-control bg-dark border-secondary text-light"
                    [(ngModel)]="sliders.acousticness.minValue">
                </div>
                <ngx-slider class="col-md" [(value)]="sliders.acousticness.minValue"
                  [(highValue)]="sliders.acousticness.maxValue" [options]="sliders?.acousticness?.options"
                  (highValueChange)="sliderChange($event, 'acousticness')">
                </ngx-slider>
                <div class="col-md-2">
                  <input type="number" class="form-control bg-dark border-secondary text-light"
                    [(ngModel)]="sliders.acousticness.maxValue">
                </div>
              </div>

              <div class="custom-control custom-checkbox">
                <input type="checkbox" id="liveness" class="custom-control-input"
                  (change)="chkRecommendChange($event, 'liveness')" [checked]="sourceData.hasOwnProperty('liveness')">
                <label class="custom-control-label" for="liveness">Liveness</label>
              </div>
              <div class="row my-3 d-flex align-items-end" *ngIf="sourceData.hasOwnProperty('liveness')">
                <div class="col-md-2">
                  <input type="number" class="form-control bg-dark border-secondary text-light"
                    [(ngModel)]="sliders.liveness.minValue">
                </div>
                <ngx-slider class="col-md" [(value)]="sliders.liveness.minValue"
                  [(highValue)]="sliders.liveness.maxValue" [options]="sliders?.liveness?.options"
                  (highValueChange)="sliderChange($event, 'liveness')">
                </ngx-slider>
                <div class="col-md-2">
                  <input type="number" class="form-control bg-dark border-secondary text-light"
                    [(ngModel)]="sliders.liveness.maxValue">
                </div>
              </div>

              <div class="custom-control custom-checkbox">
                <input type="checkbox" id="popularity" class="custom-control-input"
                  (change)="chkRecommendChange($event, 'popularity')"
                  [checked]="sourceData.hasOwnProperty('popularity')">
                <label class="custom-control-label" for="popularity">Popularity</label>
              </div>
              <div class="row my-3 d-flex align-items-end" *ngIf="sourceData.hasOwnProperty('popularity')">
                <div class="col-md-2">
                  <input type="number" class="form-control bg-dark border-secondary text-light"
                    [(ngModel)]="sliders.popularity.minValue">
                </div>
                <ngx-slider class="col-md" [(value)]="sliders.popularity.minValue"
                  [(highValue)]="sliders.popularity.maxValue" [options]="sliders?.popularity?.options"
                  (highValueChange)="sliderChange($event, 'popularity')">
                </ngx-slider>
                <div class="col-md-2">
                  <input type="number" class="form-control bg-dark border-secondary text-light"
                    [(ngModel)]="sliders.popularity.maxValue">
                </div>
              </div>

              <div class="form-row mt-3 d-flex align-items-end">
                <div class="form-group col-md-6">
                  <label for="limit">Number of tracks per video</label>
                  <input type="number" class="form-control bg-dark border-secondary text-light" placeholder="20"
                    id="limit" [(ngModel)]="sourceData.limit">
                </div>
                <div class="form-group col-md-6">
                  <div class="btn-group dropup">
                    <button type="button" class="btn btn-warning dropdown-toggle" data-toggle="dropdown"
                      (click)="checkTrack()">Check</button>
                    <div class="dropdown-menu bg-warning text-center p-3 border-0 overflow-scroll"
                      style="max-height: 300px;">
                      <div *ngIf="trackSize == null">
                        <div class="spinner-border" role="status">
                          <span class="sr-only">Loading...</span>
                        </div>
                      </div>
                      <p *ngIf="trackSize != null"><strong>{{ trackSize }}</strong> tracks</p>
                      <div *ngFor="let item of previewTracks">
                        <a class="text-dark" [href]="item?.external_urls?.spotify" target="_blank">Open in browser</a>
                        <audio controls>
                          <source [src]="item?.preview_url">
                        </audio>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="tab-pane fade" id="radio" role="tabpanel">
              <div class="form-group">
                <label for="radioText">Spotify links</label>
                <textarea class="form-control bg-dark border-secondary text-light" id="radioText" rows="5"
                  placeholder="https://open.spotify.com/track/4w1lzcaoZ1IC2K5TwjalRP&#10;https://open.spotify.com/artist/5ILrArfIV0tMURcHJN8Q07&#10;https://open.spotify.com/album/6u7oZogRE5nCTk3HTJtxns&#10;https://open.spotify.com/playlist/3Ofm8CHJMRcSKWTf8qHJgx"
                  [ngModel]="sourceData?.radio_text" (input)="radioTextChange($event)"
                  (paste)="radioTextChange($event)"></textarea>
              </div>
              <div class="row">
                <div class="form-group col-md">
                  <label for="numberTrackPlaylist">Number of tracks in Playlist</label>
                  <input type="number" class="form-control bg-dark border-secondary text-light" id="numberTrackPlaylist"
                    [ngModel]="sourceData?.number_track_playlist"
                    (ngModelChange)="numberTrackChange($event, 'playlist')">
                </div>
                <div class="form-group col-md">
                  <label for="numberTrackRadio">Number of tracks per video</label>
                  <input type="number" class="form-control bg-dark border-secondary text-light" id="numberTrackRadio"
                    [ngModel]="sourceData?.number_track_radio" (ngModelChange)="numberTrackChange($event, 'radio')">
                </div>
              </div>
              <div class="form-group custom-control custom-checkbox">
                <input type="checkbox" id="isOriginalTrack" class="custom-control-input"
                  [(ngModel)]="sourceData.is_original_track">
                <label class="custom-control-label" for="isOriginalTrack">Keep original track</label>
              </div>
            </div>

            <div class="tab-pane fade" id="playlist" role="tabpanel">
              <div *ngIf="sourceType == 6" class="row">
                <div class="col-md-8 form-group">
                  <div class="custom-control custom-checkbox custom-control-inline">
                    <input [ngModel]="sourceData?.is_boom_vip" (ngModelChange)="chkBoomVipChange($event)"
                      type="checkbox" id="isBoomVip" class="custom-control-input">
                    <label class="custom-control-label" for="isBoomVip">Boom DB</label>
                  </div>

                  <div *ngIf="sourceData?.is_boom_vip" class="row mt-2">
                    <div class="col-md">
                      <select class="custom-select bg-dark border-secondary text-light"
                        [ngModel]="sourceData?.boom_vip?.split(':').slice(-1)[0].split('__')[0]"
                        (ngModelChange)="boomVipChange($event)">
                        <option value="">Choose a genre</option>
                        <option [value]="item?.name" *ngFor="let item of boomGenres">
                          {{ item?.name }} ({{ item?.vip }} vip, {{ item?.normal }} normal)
                        </option>
                      </select>
                    </div>

                    <div class="col-md">
                      <select class="custom-select bg-dark border-secondary text-light"
                        [ngModel]="sourceData?.boom_vip?.split(':').slice(-1)[0].split('__')[1]"
                        (ngModelChange)="boomVipChange($event, 'GROUP')">
                        <option value="">Choose a group</option>
                        <option [value]="item?.id" *ngFor="let item of boomGroups">
                          {{ item?.name }} ({{ item?.vip }} vip, {{ item?.normal }} normal)
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label for="playlistText">
                  {{ sourceType == 6 ? 'Deezer links' : sourceType == 5 ? 'Drive folders' : 'Playlist links' }}
                </label>
                <textarea class="form-control bg-dark border-secondary text-light" id="playlistText" rows="5"
                  [placeholder]="sourceType == 3 ? 'https://open.spotify.com/playlist/3Ofm8CHJMRcSKWTf8qHJgx' : sourceType == 4 ? 'https://soundcloud.com/hanriverlove/sets/r-lofi-beat' : sourceType == 5 ? 'https://drive.google.com/drive/folders/1LgclUwlBxQwu-0UV62s98n5XE5pZrSyu?usp=sharing' : 'https://www.deezer.com/us/playlist/1963962142&#10;https://www.deezer.com/us/track/1493915892&#10;https://www.deezer.com/us/artist/1562681'"
                  [ngModel]="sourceData?.playlist_text" (input)="playlistTextChange($event)"
                  (paste)="playlistTextChange($event)"></textarea>
              </div>
            </div>

            <div class="tab-pane fade" id="boom" role="tabpanel">
              <div class="row">
                <div class="col-md-4 form-group">
                  <label>Genre</label>

                  <select class="custom-select bg-dark border-secondary text-light" [ngModel]="sourceData?.deezer_boom"
                    (ngModelChange)="deezerBoomChange($event)">
                    <option [value]="item?.name" *ngFor="let item of boomGenres">
                      {{ item?.name }} ({{ item?.vip }} vip, {{ item?.normal }} normal)
                    </option>
                  </select>
                </div>

                <div class="col-md-4 form-group">
                  <label>Group</label>

                  <select class="custom-select bg-dark border-secondary text-light"
                    [ngModel]="sourceData?.deezer_boom?.split('__')[1]"
                    (ngModelChange)="deezerBoomChange($event, 'GROUP')">
                    <option [value]="item?.id" *ngFor="let item of boomGroups">
                      {{ item?.name }} ({{ item?.vip }} vip, {{ item?.normal }} normal)
                    </option>
                  </select>
                </div>

                <div *ngIf="sourceData?.deezer_boom" class="col-md-4 form-group">
                  <label>Order by</label>
                  <select class="custom-select bg-dark border-secondary text-light"
                    [ngModel]="sourceData?.deezer_boom_ordering" (ngModelChange)="deezerBoomOrderingChange($event)">
                    <option value="">Random for normal</option>
                    <option value="__PRIORITY">Priority for vip</option>
                    <option value="__ID__DESC">Date NEWEST for normal</option>
                    <option value="__ID__ASC">Date OLDEST for normal</option>
                    <option value="__VIEW__DESC">Views NEWEST for normal</option>
                    <option value="__VIEW__ASC">Views OLDEST for normal</option>
                    <option value="__COUNT__DESC">Count NEWEST for normal</option>
                    <option value="__COUNT__ASC">Count OLDEST for normal</option>
                  </select>
                </div>
              </div>
            </div>

            <ng-template #sourcesListTpl>
              <ul *ngIf="sourceData?.sources?.length" class="list-group" [class.my-3]="sourceType != 8" cdkDropList
                (cdkDropListDropped)="sourceDrop($event)">
                <li *ngFor="let item of sourceData?.sources; let i = index" class="list-group-item text-light"
                  [class.bg-dark]="!['EPIC', 'OFFICIAL', 'AI', 'SYMP', 'CLAIM', 'PROMO'].includes(item?.music_type)"
                  [class.bg-success]="item?.music_type === 'EPIC'"
                  [class.bg-info]="item?.music_type === 'OFFICIAL'"
                  [class.bg-secondary]="item?.music_type === 'AI'"
                  [class.bg-purple]="item?.music_type === 'SYMP'"
                  [class.bg-warning]="item?.music_type === 'CLAIM' || item?.music_type === 'PROMO'"
                  [class.border-danger]="hasSourceValidationError(i)"
                  [style.border-width]="hasSourceValidationError(i) ? '2px' : '1px'"
                  cdkDrag>
                  <div class="form-row d-flex align-items-center">
                    <div cdkDragHandle class="mr-2">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                        class="bi bi-grip-horizontal" viewBox="0 0 16 16">
                        <path
                          d="M2 8a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm3 3a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm3 3a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm3 3a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm3 3a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
                      </svg>
                    </div>

                    <div class="col-md">
                      <input [ngModel]="getSourceLabel(item)" disabled
                        class="form-control form-control-sm bg-dark border-secondary text-light" type="text">
                    </div>

                    <div *ngIf="!sourceData?.is_boom_vip" class="col-md-3 input-group input-group-sm">
                      <input [(ngModel)]="item.number_vip" type="number"
                        class="form-control form-control-sm bg-dark border-secondary text-light border-right-0">
                      <div class="input-group-append">
                        <span class="input-group-text bg-dark border-secondary text-secondary border-left-0">Tracks</span>
                      </div>
                    </div>

                    <div *ngIf="sourceType == 8 && !isPortrait" class="col-md-3 input-group input-group-sm">
                      <input [(ngModel)]="item.repeat" type="number"
                        class="form-control form-control-sm bg-dark border-secondary text-light border-right-0">
                      <div class="input-group-append">
                        <span class="input-group-text bg-dark border-secondary text-secondary border-left-0">Repeat</span>
                      </div>
                    </div>

                    <div class="d-flex align-items-center pl-2" *ngIf="item?.music_idx">
                      <svg (click)="cloneSource(item)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                        class="bi bi-copy mr-2 c-pointer" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1z"/>
                      </svg>
                      <svg (click)="removeSource(item, i)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                        class="bi bi-trash c-pointer" viewBox="0 0 16 16">
                        <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z"/>
                        <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z"/>
                      </svg>
                    </div>
                  </div>
                </li>
              </ul>
            </ng-template>

            <div class="tab-pane fade" id="boomX" role="tabpanel">
              <div class="row">
                <div class="col-md-4">
                  <mat-form-field appearance="fill" class="w-100 mb-3">
                    <mat-label>Groups</mat-label>
                    <mat-select [compareWith]="editorService.matCompareWithId" [ngModel]="sourceData?.booms_x" (ngModelChange)="boomXChange($event, 'booms_x')" multiple>
                      <mat-select-trigger class="text-light">
                        {{ editorService.getGroupName((sourceData?.booms_x || [])[0], boomGroups) }}
                        <span *ngIf="sourceData?.booms_x?.length > 1">
                          (+{{ sourceData.booms_x.length - 1 }}
                          {{ sourceData.booms_x.length == 2 ? 'other' : 'others' }})
                        </span>
                      </mat-select-trigger>

                      <mat-optgroup>
                        <mat-form-field class="w-100">
                          <input matInput placeholder="Search" #boomXFilter (keydown)="$event.stopPropagation()">
                        </mat-form-field>
                      </mat-optgroup>

                      <mat-option *ngFor="let item of boomGroups" [value]="item"
                        [ngClass]="{
                          'd-none': !item?.name.toLowerCase().includes(boomXFilter.value.toLowerCase()),
                          'bg-success text-white': item.type === 'EPIC',
                          'text-info': item.type === 'OFFICIAL',
                          'text-secondary': item.type === 'AI',
                          'text-purple': item.type === 'SYMP'
                        }">
                        <span *ngIf="item?.type !== 'NORMAL'" class="badge badge-light">{{ item?.type }}</span>
                        {{ item?.name }} ({{ item?.vip }} vip, {{ item?.normal }} normal{{ item?.highlight_count ? ', ' + item.highlight_count + ' shorts' : '' }})
                      </mat-option>
                    </mat-select>
                  </mat-form-field>

                  <mat-form-field appearance="fill" class="w-100 mb-3">
                    <mat-label>Claims</mat-label>
                    <mat-select [ngModel]="sourceData?.claims" (ngModelChange)="boomXChange($event, 'claims')" multiple>
                      <mat-select-trigger class="text-light">
                        {{ (sourceData?.claims || [])[0] }}
                        <span *ngIf="sourceData?.claims?.length > 1">
                          (+{{ sourceData.claims.length - 1 }}
                          {{ sourceData.claims.length == 2 ? 'other' : 'others' }})
                        </span>
                      </mat-select-trigger>

                      <mat-optgroup>
                        <mat-form-field class="w-100">
                          <input matInput placeholder="Search" #claimsXFilter (keydown)="$event.stopPropagation()">
                        </mat-form-field>
                      </mat-optgroup>

                      <mat-option [value]="item?.topic" *ngFor="let item of getSelectableTopics(claimTopics)"
                        [ngClass]="{ 'd-none': !item?.topic.toLowerCase().includes(claimsXFilter.value.toLowerCase()) }">
                        {{ item?.topic }} ({{ item?.total || 0 }})
                      </mat-option>
                    </mat-select>
                  </mat-form-field>

                  <mat-form-field appearance="fill" class="w-100 mb-3">
                    <mat-label>Promos</mat-label>
                    <mat-select [ngModel]="sourceData?.promos" (ngModelChange)="boomXChange($event, 'promos')" multiple>
                      <mat-select-trigger class="text-light">
                        {{ (sourceData?.promos || [])[0] }}
                        <span *ngIf="sourceData?.promos?.length > 1">
                          (+{{ sourceData.promos.length - 1 }}
                          {{ sourceData.promos.length == 2 ? 'other' : 'others' }})
                        </span>
                      </mat-select-trigger>

                      <mat-optgroup>
                        <mat-form-field class="w-100">
                          <input matInput placeholder="Search" #promosXFilter (keydown)="$event.stopPropagation()">
                        </mat-form-field>
                      </mat-optgroup>

                      <mat-option [value]="item?.topic" *ngFor="let item of getSelectableTopics(promoTopics)"
                        [ngClass]="{ 'd-none': !item?.topic.toLowerCase().includes(promosXFilter.value.toLowerCase()) }">
                        {{ item?.topic }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <div class="col-md">
                  <ng-container *ngTemplateOutlet="sourcesListTpl"></ng-container>
                </div>
              </div>
            </div>

            <div *ngIf="sourceType != 1 && sourceType != 2">
              <ng-container *ngIf="sourceType != 8">
                <ng-container *ngTemplateOutlet="sourcesListTpl"></ng-container>

                <div class="row">
                  <div class="form-group col-md">
                    <label for="numberTrackVideo">Number of tracks per video</label>
                    <input [(ngModel)]="sourceData.number_track_video" type="text"
                      class="form-control bg-dark border-secondary text-light" id="numberTrackVideo">
                  </div>

                  <div *ngIf="sourceData?.positions?.length" class="form-group col-md">
                    <label for="trackVip">Number of tracks</label>
                    <input [ngModel]="sourceData?.track_vip" disabled type="text"
                      class="form-control bg-dark border-secondary text-light" id="trackVip">
                  </div>

                  <div *ngIf="sourceData?.positions?.length" class="form-group col-md">
                    <label for="repeat">Repeat</label>
                    <input [(ngModel)]="sourceData.repeat" type="number"
                      class="form-control bg-dark border-secondary text-light" id="repeat">
                  </div>
                </div>

                <div class="form-group">
                  <div *ngIf="sourceType == 3" class="custom-control custom-checkbox custom-control-inline">
                    <input [(ngModel)]="sourceData.is_radio_vip" type="checkbox" id="isRadioVip"
                      class="custom-control-input">
                    <label class="custom-control-label" for="isRadioVip">Radio by tracks</label>
                  </div>

                  <div class="custom-control custom-checkbox custom-control-inline">
                    <input [(ngModel)]="sourceData.is_rand_pick" type="checkbox" id="isRandPick"
                      class="custom-control-input">
                    <label class="custom-control-label" for="isRandPick">Random between playlists</label>
                  </div>

                  <div class="custom-control custom-checkbox custom-control-inline">
                    <input [(ngModel)]="sourceData.is_mix_playlist" type="checkbox" id="isMixPlaylist"
                      class="custom-control-input">
                    <label class="custom-control-label" for="isMixPlaylist">Mix playlists</label>
                  </div>
                </div>

                <div class="range-control">
                  <button type="button" class="btn btn-sm btn-secondary mr-2" (click)="addRange()">Add range</button>
                  <button type="button" class="btn btn-sm btn-danger" (click)="deleteRange()">Del range</button>
                  <div class="px-4 py-5 my-3">
                    <div #range></div>
                  </div>
                </div>
              </ng-container>
            </div>

            <div *ngIf="sourceType == 8" class="form-group row">
              <div *ngIf="!isPortrait" class="col-md-3">
                <label for="repeatAll">Repeat All</label>
                <input [(ngModel)]="sourceData.repeat_all" type="number" class="form-control bg-dark border-secondary text-light" id="repeatAll">
              </div>

              <div *ngIf="isPortrait" class="col-md-3">
                <div>
                    <label>
                      Short choosing
                      <small class="d-block">{{ sourceData.short_choosing == 'priority' ? 'Chỉ lấy đoạn hay nhất' : sourceData.short_choosing == 'recommendations' ? 'Ngẫu nhiên trong 1-3 đoạn theo đề xuất TikTok' : 'Ngẫu nhiên trong 4-6 đoạn nổi bật' }}</small>
                    </label>
                  <select class="custom-select bg-dark border-secondary text-light" [(ngModel)]="sourceData.short_choosing">
                    <option [selected]="sourceData.short_choosing == 'priority'" value="priority">Best Priority</option>
                    <option [selected]="sourceData.short_choosing == 'recommendations'" value="recommendations">TikTok Recommendations</option>
                    <option [selected]="sourceData.short_choosing == 'highlights'" value="highlights">Highlights</option>
                  </select>
                </div>
              </div>
            </div>

            <div *ngIf="!isPortrait && sourceType != 8" class="custom-control custom-checkbox">
              <input type="checkbox" id="claim" class="custom-control-input"
                (change)="chkRecommendChange($event, 'claim')" [checked]="sourceData.hasOwnProperty('claim')">
              <label class="custom-control-label" for="claim">Claim or Promo</label>
            </div>

            <div *ngIf="sourceData.hasOwnProperty('claim')" class="mt-3">
              <div class="form-row">
                <div class="col-md form-group">
                  <div class="custom-control custom-radio custom-control-inline">
                    <input [ngModel]="sourceData.claim?.topic_type" (ngModelChange)="topicTypeChange($event)"
                      value="CLAIM" type="radio" id="topicTypeClaim" name="topicType" class="custom-control-input">
                    <label class="custom-control-label" for="topicTypeClaim">Claim topic</label>
                  </div>

                  <div class="custom-control custom-radio custom-control-inline">
                    <input [ngModel]="sourceData.claim?.topic_type" (ngModelChange)="topicTypeChange($event)"
                      value="PROMOS" type="radio" id="topicTypePromo" name="topicType" class="custom-control-input">
                    <label class="custom-control-label" for="topicTypePromo">Promo topic</label>
                  </div>

                  <select [(ngModel)]="sourceData.claim.topic"
                    [disabled]="!sourceData.claim.hasOwnProperty('topic_type')"
                    class="custom-select bg-dark border-secondary text-light mt-2">
                    <option value="">Choose a topic</option>
                    <option [ngValue]="item?.topic" *ngFor="let item of claimList">{{ item?.topic }}</option>
                  </select>
                </div>

                <div class="col-md form-group">
                  <label for="numberClaim">Number</label>
                  <input type="text" class="form-control bg-dark border-secondary text-light" id="numberClaim"
                    [(ngModel)]="sourceData.claim.number">
                </div>
              </div>

              <div class="mb-3">
                <label>Position</label>
                <div class="row d-flex align-items-end">
                  <div class="col-md-2">
                    <input type="number" class="form-control bg-dark border-secondary text-light"
                      [(ngModel)]="sliders.claim.minValue">
                  </div>

                  <ngx-slider class="col-md" [(value)]="sliders.claim.minValue" [(highValue)]="sliders.claim.maxValue"
                    [options]="sliders?.claim?.options" (highValueChange)="sliderChange($event, 'claim')">
                  </ngx-slider>

                  <div class="col-md-2">
                    <input type="number" class="form-control bg-dark border-secondary text-light"
                      [(ngModel)]="sliders.claim.maxValue">
                  </div>
                </div>
              </div>
            </div>

            <div *ngIf="!isPortrait" class="custom-control custom-checkbox">
              <input type="checkbox" id="isDistinctArtist" class="custom-control-input"
                [(ngModel)]="sourceData.is_distinct_artist">
              <label class="custom-control-label" for="isDistinctArtist" data-toggle="tooltip" data-placement="top"
                title="Chỉ Distinct các bài hát của artists không trong hệ thống CLAIM">Distinct artist</label>
            </div>
          </div>
        </div>

        <div
          *ngIf="controlType.includes('image') || controlType.includes('video')">
          <div class="form-row form-group align-items-end">
            <div class="col-md">
              <label>Algorithm</label>
              <select class="form-control bg-dark border-secondary text-light" [ngModel]="hubData?.al"
                (ngModelChange)="algorithmChange($event)">
                <option value="random-unique" [selected]="hubData?.al == 'random-unique'">Random Unique</option>
                <option value="random-order" [selected]="hubData?.al == 'random-order'">Random Order</option>
                <option value="sequence-unique" [selected]="hubData?.al == 'sequence-unique'">Sequence Unique</option>
                <option value="sequence-normal" [selected]="hubData?.al == 'sequence-normal'">Sequence Normal</option>
              </select>
            </div>
            <div class="input-group col-md">
              <div class="custom-file">
                <input multiple type="file" class="custom-file-input" id="zipFile"
                  [accept]="controlType.includes('image') ? 'image/*' : '.avi,.m4v,.mp4,.webm,.gif'"
                  (change)="awsFilesInput($event.target.files, controlType.includes('image') ? 'image' : 'video')">
                <span class="custom-file-label bg-dark border-secondary text-light" for="zipFile">Choose files{{ controlType.includes('video') ? ' (AVI, M4V, MP4, WEBM or GIF)' : '' }}</span>
              </div>
            </div>
          </div>
          <div class="mb-3">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text" for="driveZip">
                  <img src="https://ssl.gstatic.com/images/branding/product/1x/drive_2020q4_32dp.png" width="20">
                </span>
              </div>
              <input type="text" class="form-control bg-dark border-secondary text-light"
                placeholder="Drive folder link" id="driveZip"
                [value]="layerData?.last_drive_link ? layerData?.last_drive_link : null"
                (keyup.enter)="zipFileInput($event.target.value, controlType.includes('image') ? 'image-drive-zip' : 'video-drive-zip')">
            </div>
            <small class="text-muted">
              Example:<br>
              https://drive.google.com/drive/folders/1fybShLYI-xhR4c82FrgFLBinyQZP6qLn?usp=sharing<br>
              https://drive.google.com/file/d/0B2zRoYfJBS9pem5LM19IX29yTkE/view?usp=sharing
            </small>
          </div>
          <!-- <button type="button" class="btn btn-secondary" id="btnCanvaHub" (click)="canvaHubClick()">
            Use Canva Hub
          </button> -->
        </div>

        <div class="d-flex justify-content-center" *ngIf="isLoading">
          <img src="/assets/images/loading.gif" width="50">
        </div>

        <div *ngIf="uploadStatus[uploadStatusType]?.progress && uploadStatus[uploadStatusType]?.progress < 100" class="progress" style="height: 10px;">
          <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" [style.width.%]="uploadStatus[uploadStatusType].progress" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100">
            {{ uploadStatus[uploadStatusType].count }}/{{ uploadStatus[uploadStatusType].total }} files
          </div>
        </div>
      </div>

      <div class="modal-footer"
        *ngIf="controlType == 'lyric' || controlType == 'compilation' || controlType == 'mix_lyric' || controlType.includes('collection:music')">
        <div *ngIf="sourceType == 8 && sourceData?.sources?.length && getSourceTracksSummary() as summary" class="mr-auto text-warning">
          {{ summary.total }} Tracks
          (<span *ngFor="let item of summary.musicTypes | keyvalue; let last = last">{{ item.key }}: {{ item.value * (sourceData?.repeat_all || 1) }}<ng-container *ngIf="!last">, </ng-container></span>)
        </div>
        <button type="button" class="btn btn-danger" (click)="resetSource()" data-toggle="tooltip" data-placement="top" title="Reset old data">Reset</button>
        <button type="button" class="btn btn-primary" (click)="saveSource()">Save changes</button>
      </div>
    </div>
  </div>
</div>

<div class="modal right fade" tabindex="-1" id="effectModal">
  <div class="modal-dialog modal-sm">
    <div class="modal-content bg-dark text-light">
      <div class="modal-body">
        <div class="d-flex flex-wrap align-items-start">
          <div class="d-flex flex-column text-center c-pointer" (click)="effectClick('none')">
            <img [ngClass]="{ 'shadow-primary': layerData?.effect?.type == 'none' }" class="rounded m-1" width="80"
              src="https://static.canva.com/web/images/90da4f3cd9128e7939fcb61dabe0b690.png">
            <label>None</label>
          </div>
          <div class="d-flex flex-column text-center c-pointer" (click)="effectClick('shadow')">
            <img [ngClass]="{ 'shadow-primary': layerData?.effect?.type == 'shadow' }" class="rounded m-1" width="80"
              src="https://static.canva.com/web/images/544ebef63f65bc118af1a353d8e3456c.png">
            <label>Shadow</label>
          </div>
          <div class="d-flex flex-column text-center c-pointer" (click)="effectClick('splice')">
            <img [ngClass]="{ 'shadow-primary': layerData?.effect?.type == 'splice' }" class="rounded m-1" width="80"
              src="https://static.canva.com/web/images/6bec5afe4433f7030024ed9287752d08.png">
            <label>Splice</label>
          </div>
          <div class="d-flex flex-column text-center c-pointer" (click)="effectClick('echo')">
            <img [ngClass]="{ 'shadow-primary': layerData?.effect?.type == 'echo' }" class="rounded m-1" width="80"
              src="https://static.canva.com/web/images/3df11ae4feb176c0e1326a83078863d2.png">
            <label>Echo</label>
          </div>
          <div class="d-flex flex-column text-center c-pointer" (click)="effectClick('glitch')">
            <img [ngClass]="{ 'shadow-primary': layerData?.effect?.type == 'glitch' }" class="rounded m-1" width="80"
              src="https://static.canva.com/web/images/10d3bc08aa9d6ba94ddba7a67a6ff83e.png">
            <label>Glitch</label>
          </div>
        </div>
        <div *ngFor="let item of effectSliders">
          <div *ngIf="layerData?.effect?.type != 'glitch'">
            <label class="m-0">{{ item.label }}</label>
            <div class="form-row d-flex align-items-end">
              <div class="col-md">
                <ngx-slider [(value)]="item.value" [options]="item?.options"
                  (valueChange)="effectSliderChange($event, item)">
                </ngx-slider>
              </div>
              <div class="col-md-4">
                <input type="number" class="form-control bg-dark border-secondary text-light" [(ngModel)]="item.value">
              </div>
            </div>
          </div>
          <div *ngIf="layerData?.effect?.type == 'glitch' && item.type != 'opacity'">
            <label class="m-0">{{ item.label }}</label>
            <div class="form-row d-flex align-items-end">
              <div class="col-md">
                <ngx-slider [(value)]="item.value" [options]="item?.options"
                  (valueChange)="effectSliderChange($event, item)">
                </ngx-slider>
              </div>
              <div class="col-md-4">
                <input type="number" class="form-control bg-dark border-secondary text-light" [(ngModel)]="item.value">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal right fade" tabindex="-1" id="textListModal">
  <div class="modal-dialog modal-sm">
    <div class="modal-content bg-dark text-light">
      <div class="modal-body">
        <div class="form-group">
          <label for="oldJobId">Old job ID (default fake 20 songs)</label>
          <input type="number" class="form-control bg-dark border-secondary text-light" placeholder="xxx" id="oldJobId"
            [(ngModel)]="layerData.job_id" title="Job ID of Compilation or Mix lyric">
        </div>

        <button type="button" class="btn btn-primary" (click)="testTextList($event)">Test</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="soundEffectModal">
  <div class="modal-dialog modal-dialog-scrollable modal-xl">
    <div class="modal-content bg-dark text-light">
      <div class="modal-header">
        <h5 class="modal-title">Sound Effect</h5>
        <button type="button" class="close" data-dismiss="modal">
          <span>&times;</span>
        </button>
      </div>

      <div class="modal-body">
        <div *ngFor="let soundEffect of soundEffectData?.sound_effects; let i = index" class="row align-items-center mb-3">
          <mat-form-field appearance="fill" class="col-md">
            <mat-label>Group</mat-label>
            <mat-select [compareWith]="editorService.matCompareWithId" [ngModel]="soundEffectData?.sound_effects[i]?.group"
              (ngModelChange)="soundEffectChange($event, 'sound_effects', i)">
              <mat-select-trigger class="text-light">
                {{ editorService.getGroupName(soundEffectData?.sound_effects[i]?.group, boomGroups) }}
              </mat-select-trigger>

              <mat-optgroup>
                <mat-form-field class="w-100">
                  <input matInput placeholder="Search" #soundEffectFilter (keydown)="$event.stopPropagation()">
                </mat-form-field>
              </mat-optgroup>

              <mat-option *ngFor="let item of boomGroups" [value]="'GROUP__' + item?.id"
                [ngClass]="{ 'd-none': !item?.name.toLowerCase().includes(soundEffectFilter.value.toLowerCase()) }">
                {{ item?.name }} ({{ item?.vip }} vip, {{ item?.normal }} normal)
              </mat-option>
            </mat-select>
          </mat-form-field>

          <div class="d-flex align-items-center pr-4">
            <svg (click)="removeSoundEffect('sound_effects', i)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
              class="bi bi-trash mr-2 c-pointer" viewBox="0 0 16 16">
              <path
                d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6Z" />
              <path
                d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1ZM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118ZM2.5 3h11V2h-11v1Z" />
            </svg>

            <svg (click)="newSoundEffect('sound_effects')" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
              class="bi bi-plus-lg c-pointer" viewBox="0 0 16 16">
              <path fill-rule="evenodd"
                d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2Z" />
            </svg>
          </div>
        </div>

        <ul *ngIf="soundEffectData?.sources?.length" class="list-group mb-3" cdkDropList (cdkDropListDropped)="soundEffectDrop($event)">
          <li *ngFor="let item of soundEffectData?.sources; let i = index" class="list-group-item bg-dark text-light" cdkDrag>
            <div class="form-row d-flex align-items-center">
              <div cdkDragHandle class="mr-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                  class="bi bi-grip-horizontal" viewBox="0 0 16 16">
                  <path
                    d="M2 8a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm3 3a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm3 3a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm3 3a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm3 3a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
                </svg>
              </div>

              <div class="col-md">
                <input [ngModel]="editorService.getGroupName(item?.uri?.split(':')?.pop(), boomGroups)" disabled
                  class="form-control form-control-sm bg-dark border-secondary text-light" type="text">
              </div>

              <div class="col-md-3 input-group input-group-sm">
                <input [(ngModel)]="item.number_vip" type="number"
                  class="form-control form-control-sm bg-dark border-secondary text-light border-right-0">
                <div class="input-group-append">
                  <span class="input-group-text bg-dark border-secondary text-secondary border-left-0">Tracks</span>
                </div>
              </div>

              <div class="col-md-3 input-group input-group-sm">
                <input [(ngModel)]="item.repeat" (input)="validRepeat($event, i)" type="number" min="1" max="10"
                  class="form-control form-control-sm bg-dark border-secondary text-light border-right-0">
                <div class="input-group-append">
                  <span class="input-group-text bg-dark border-secondary text-secondary border-left-0">Repeat</span>
                </div>
              </div>

              <div class="col-md-3 input-group input-group-sm">
                <input [(ngModel)]="item.volume" type="number" step="10" min="0" max="200"
                  class="form-control form-control-sm bg-dark border-secondary text-light border-right-0">
                <div class="input-group-append">
                  <span class="input-group-text bg-dark border-secondary text-secondary border-left-0">Volume</span>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>

      <div class="modal-footer">
        <div *ngIf="soundEffectData?.sources?.length" class="mr-auto text-warning">{{ getSoundEffectTracks() }} Tracks</div>
        <button type="button" class="btn btn-danger" (click)="resetSoundEffect()" data-toggle="tooltip" data-placement="top" title="Reset old data">Reset</button>
        <button type="button" class="btn btn-primary" (click)="saveSoundEffect()">Save changes</button>
      </div>
    </div>
  </div>
</div>

<ng-template #tplCodeField>
  <div class="form-group">
    <label for="tplCode">Template code</label>
    <div mwlTextInputHighlightContainer class="bg-gray">
      <textarea mwlTextInputElement #tplCode class="form-control bg-transparent border-0 text-light" id="tplCode"
        rows="1" [mentionConfig]="mentionConfig" [ngModel]="layerData?.lang_code"
        (ngModelChange)="tplCodeChange($event)"></textarea>
      <mwl-text-input-highlight [tags]="highlightTag?.lang_code" [textInputElement]="tplCode">
      </mwl-text-input-highlight>
    </div>
  </div>
</ng-template>
